<template>
	<div class="sidebar">
		<div class="logo-img">
			<div class="logo">
				<img class="img" :src="webInfo.topSmallPicture" alt="" />
				<img v-if="!collapse" class="img-text" :src="webInfo.topBigPicture" alt="" />
			</div>
		</div>
		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router
			v-if="role == 'admin'">
			<el-menu-item index="dashboard" :class="onRoutes == 'dashboard' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'dashboard' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">&#xe6af;</span>
				<span>系统首页</span>
			</el-menu-item>

			<el-submenu index="customer">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'modou' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;">&#xe645;</span>
					<span :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'automaticRecycling' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'modou' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]">CRM管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="CRMstatistics"
						:class="onRoutes == 'CRMstatistics' ? theme6 : ''">统计报表</el-menu-item>
					<el-menu-item index="customer" :class="onRoutes == 'customer' ? theme6 : ''">我的客户</el-menu-item>
					<el-menu-item index="CRMHigh" :class="onRoutes == 'CRMHigh' ? theme6 : ''">公海客户</el-menu-item>
					<!-- <el-menu-item index="CRMDepartmentHigh"
						:class="onRoutes == 'CRMDepartmentHigh' ? theme6 : ''">部门公海</el-menu-item> -->
					<el-menu-item index="customTag" :class="onRoutes == 'customTag' ? theme6 : ''">字段配置</el-menu-item>
					<el-menu-item index="followProgress"
						:class="onRoutes == 'followProgress' ? theme6 : ''">跟进阶段配置</el-menu-item>
					<el-menu-item index="CRMsource" :class="onRoutes == 'CRMsource' ? theme6 : ''">来源配置</el-menu-item>
					<el-menu-item index="release" :class="onRoutes == 'release' ? theme6 : ''">释放管理</el-menu-item>
					<el-menu-item index="automaticRecycling"
						:class="onRoutes == 'automaticRecycling' ? theme6 : ''">自动回收</el-menu-item>
					<el-menu-item index="tag" :class="onRoutes == 'tag' ? theme6 : ''">标签管理</el-menu-item>
					<el-menu-item index="clueCollection"
						:class="onRoutes == 'clueCollection' ? theme6 : ''">领取记录</el-menu-item>
					<el-menu-item index="operationRecord"
						:class="onRoutes == 'operationRecord' ? theme6 : ''">操作记录</el-menu-item>
					<el-menu-item index="modou" :class="onRoutes == 'modou' ? theme6 : ''">模版管理</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="clue">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'clue' ? theme3 : '',
							onRoutes == 'assignLeads' ? theme3 : '',
							onRoutes == 'groupCall' ? theme3 : '',
							onRoutes == 'cluePool' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;font-weight: 600;">&#xe738;</span>
					<span :class="[
							onRoutes == 'clue' ? theme3 : '', 
							onRoutes == 'assignLeads' ? theme3 : '', 
							onRoutes == 'groupCall' ? theme3 : '', 
							onRoutes == 'cluePool' ? theme3 : '']">线索管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="clue" :class="onRoutes == 'clue' ? theme6 : ''">线索列表</el-menu-item>
					<!-- <el-menu-item index="groupCall" :class="onRoutes == 'groupCall' ? theme6 : ''">群呼列表</el-menu-item> -->
					<el-menu-item index="assignLeads"
						:class="onRoutes == 'assignLeads' ? theme6 : ''">线索回收</el-menu-item>
					<el-menu-item index="cluePool" :class="onRoutes == 'cluePool' ? theme6 : ''">线索池</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="company">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'company' ? theme3 : '', 
							onRoutes == 'department' ? theme3 : '', 
							onRoutes == 'user' ? theme3 : '', 
							onRoutes == 'addressErrList' ? theme3 : '', 
							onRoutes == 'enterpriseAudit' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">&#xe818;</span>
					<span :class="[
							onRoutes == 'company' ? theme3 : '', 
							onRoutes == 'department' ? theme3 : '', 
							onRoutes == 'user' ? theme3 : '', 
							onRoutes == 'addressErrList' ? theme3 : '', 
							onRoutes == 'enterpriseAudit' ? theme3 : '']">企业管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="company" :class="onRoutes == 'company' ? theme6 : ''">企业列表</el-menu-item>
					<el-menu-item index="department" :class="onRoutes == 'department' ? theme6 : ''">部门管理</el-menu-item>
					<el-menu-item index="user" :class="onRoutes == 'user' ? theme6 : ''">员工管理</el-menu-item>
					<el-menu-item index="addressErrList"
						:class="onRoutes == 'addressErrList' ? theme6 : ''">位置异常</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="record" :class="onRoutes == 'record' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'record' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;font-weight: 600;;">&#xe64b;</span>
				<span>通话记录</span>
			</el-menu-item>
			<el-menu-item index="cjabnormalCall" :class="onRoutes == 'cjabnormalCall' ? theme3 : ''"
				v-if="webName == '橙逸通信'">
				<i class="el-icon-s-shop"></i>
				<span>长江异常话单</span>
			</el-menu-item>

			<el-submenu index="GMvirtualCommerce">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'GMvirtualCommerce' ? theme3 : '',
							onRoutes == 'WNvirtualCommerce' ? theme3 : '',
							onRoutes == 'CYWNvirtualCommerce' ? theme3 : '',
							onRoutes == 'DJvirtualCommerce' ? theme3 : '',
							onRoutes == 'CCvirtualCommerce' ? theme3 : '',
							onRoutes == 'enterpriseLimiting' ? theme3 : '',]"
						style="font-size:16px !important;margin-right:10px !important;">&#xe98a;</span>
					<span :class="[
							onRoutes == 'GMvirtualCommerce' ? theme3 : '',
							onRoutes == 'WNvirtualCommerce' ? theme3 : '',
							onRoutes == 'CYWNvirtualCommerce' ? theme3 : '',
							onRoutes == 'DJvirtualCommerce' ? theme3 : '',
							onRoutes == 'CCvirtualCommerce' ? theme3 : '',
							onRoutes == 'enterpriseLimiting' ? theme3 : '']">虚商管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="WNvirtualCommerce"
						:class="onRoutes == 'WNvirtualCommerce' ? theme6 : ''">蜗牛管理</el-menu-item>
					<el-menu-item index="DJvirtualCommerce"
						:class="onRoutes == 'DJvirtualCommerce' ? theme6 : ''">迪加管理</el-menu-item>
					<el-menu-item index="CYWNvirtualCommerce"
						:class="onRoutes == 'CYWNvirtualCommerce' ? theme6 : ''">CY蜗牛管理</el-menu-item>
					<el-menu-item index="GMvirtualCommerce"
						:class="onRoutes == 'GMvirtualCommerce' ? theme6 : ''">国美管理</el-menu-item>
					<el-menu-item index="CCvirtualCommerce"
						:class="onRoutes == 'CCvirtualCommerce' ? theme6 : ''">长城管理</el-menu-item>
					<el-menu-item index="enterpriseLimiting"
						:class="onRoutes == 'enterpriseLimiting' ? theme6 : ''">企业限频</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<!-- 
			<el-submenu index="wnQuery" v-if="webName == '云企通'">
				<template v-slot:title>
					<i class="el-icon-discount" :class="[
							onRoutes == 'WNrestartRecordList' ? theme3 : '',
							onRoutes == 'accountOpeningProgress' ? theme3 : '',
							onRoutes == 'WNAbnormalCallList' ? theme3 : '',
							onRoutes == 'wnQuery' ? theme3 : '',
							onRoutes == 'wnRecharge' ? theme3 : '',
							onRoutes == 'preDeposit' ? theme3 : '',
							onRoutes == 'frequencyLimit' ? theme3 : '',
							onRoutes == 'batchAccountClosure' ? theme3 : '',
							onRoutes == 'WNWhitelist' ? theme3 : ''
						]"></i>
					<span :class="[
							onRoutes == 'WNrestartRecordList' ? theme3 : '',
							onRoutes == 'accountOpeningProgress' ? theme3 : '',
							onRoutes == 'WNAbnormalCallList' ? theme3 : '',
							onRoutes == 'wnQuery' ? theme3 : '',
							onRoutes == 'wnRecharge' ? theme3 : '',
							onRoutes == 'preDeposit' ? theme3 : '',
							onRoutes == 'frequencyLimit' ? theme3 : '',
							onRoutes == 'batchAccountClosure' ? theme3 : '',
							onRoutes == 'WNWhitelist' ? theme3 : ''
						]">蜗牛管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="wnQuery" :class="onRoutes == 'wnQuery' ? theme6 : ''">蜗牛查询</el-menu-item>
					<el-menu-item index="wnRecharge" :class="onRoutes == 'wnRecharge' ? theme6 : ''">蜗牛充值</el-menu-item>
					<el-menu-item index="preDeposit"
						:class="onRoutes == 'preDeposit' ? theme6 : ''">蜗牛预存款</el-menu-item>
					<el-menu-item index="frequencyLimit"
						:class="onRoutes == 'frequencyLimit' ? theme6 : ''">呼叫限频</el-menu-item>
					<el-menu-item index="WNrestartRecordList"
						:class="onRoutes == 'WNrestartRecordList' ? theme6 : ''">停复机</el-menu-item>
					<el-menu-item index="accountOpeningProgress"
						:class="onRoutes == 'accountOpeningProgress' ? theme6 : ''">开户进度</el-menu-item>
					<el-menu-item index="WNAbnormalCallList"
						:class="onRoutes == 'WNAbnormalCallList' ? theme6 : ''">异常话单</el-menu-item>
					<el-menu-item index="WNWhitelist"
						:class="onRoutes == 'WNWhitelist' ? theme6 : ''">批量加白</el-menu-item>
					<el-menu-item index="batchAccountClosure"
						:class="onRoutes == 'batchAccountClosure' ? theme6 : ''">批量销户</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="wnQueryCY" v-if="webName == '云企通'">
				<template v-slot:title>
					<i class="el-icon-news" :class="[
						onRoutes == 'wnQueryCY' ? theme3 : '',
						onRoutes == 'WNrestartRecordListCY' ? theme3 : '',
						onRoutes == 'accountOpeningProgressCY' ? theme3 : '',
						onRoutes == 'frequencyLimitCY' ? theme3 : '',
						onRoutes == 'WNAbnormalCallListCY' ? theme3 : '',
						onRoutes == 'WNWhitelistCY' ? theme3 : '',
						onRoutes == 'batchAccountClosureCY' ? theme3 : '',
						]"></i>
					<span :class="[
							onRoutes == 'wnQueryCY' ? theme3 : '',
							onRoutes == 'WNrestartRecordListCY' ? theme3 : '',
							onRoutes == 'accountOpeningProgressCY' ? theme3 : '',
							onRoutes == 'frequencyLimitCY' ? theme3 : '',
							onRoutes == 'WNAbnormalCallListCY' ? theme3 : '',
							onRoutes == 'WNWhitelistCY' ? theme3 : '',
							onRoutes == 'batchAccountClosureCY' ? theme3 : '',
						]">CY蜗牛管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="wnQueryCY" :class="onRoutes == 'wnQueryCY' ? theme6 : ''">CY蜗牛查询</el-menu-item>
					<el-menu-item index="WNrestartRecordListCY"
						:class="onRoutes == 'WNrestartRecordListCY' ? theme6 : ''">CY停复机</el-menu-item>
					<el-menu-item index="accountOpeningProgressCY"
						:class="onRoutes == 'accountOpeningProgressCY' ? theme6 : ''">CY开户进度</el-menu-item>
					<el-menu-item index="frequencyLimitCY"
						:class="onRoutes == 'frequencyLimitCY' ? theme6 : ''">CY呼叫限频</el-menu-item>
					<el-menu-item index="WNAbnormalCallListCY"
						:class="onRoutes == 'WNAbnormalCallListCY' ? theme6 : ''">CY异常话单</el-menu-item>
					<el-menu-item index="WNWhitelistCY"
						:class="onRoutes == 'WNWhitelistCY' ? theme6 : ''">CY批量加白</el-menu-item>
					<el-menu-item index="batchAccountClosureCY"
						:class="onRoutes == 'batchAccountClosureCY' ? theme6 : ''">CY批量销户</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->



			<!-- <el-submenu index="userInfo" v-if="webName == '云企通'">
				<template v-slot:title>
					<i class="el-icon-bank-card" :class="[
							onRoutes == 'userInfo' ? theme3 : '',
							onRoutes == 'restartRecordList' ? theme3 : '',
							onRoutes == 'activationList' ? theme3 : '',
							onRoutes == 'NoShutdownMaintenanceNumber' ? theme3 : '',
							onRoutes == 'djRecharge' ? theme3 : '',
							onRoutes == 'djRebateList' ? theme3 : '',
							onRoutes == 'DJAbnormalCallList' ? theme3 : '',
							onRoutes == 'DJfreeze' ? theme3 : '',
							onRoutes == 'numberControl' ? theme3 : '',
							onRoutes == 'accountReview' ? theme3 : '']"></i>
					<span :class="[
							onRoutes == 'userInfo' ? theme3 : '',
							onRoutes == 'restartRecordList' ? theme3 : '',
							onRoutes == 'activationList' ? theme3 : '',
							onRoutes == 'NoShutdownMaintenanceNumber' ? theme3 : '',
							onRoutes == 'djRecharge' ? theme3 : '',
							onRoutes == 'djRebateList' ? theme3 : '',
							onRoutes == 'DJAbnormalCallList' ? theme3 : '',
							onRoutes == 'DJfreeze' ? theme3 : '',
							onRoutes == 'numberControl' ? theme3 : '',
							onRoutes == 'accountReview' ? theme3 : ''
						]">迪加管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="userInfo" :class="onRoutes == 'userInfo' ? theme6 : ''">迪加查询</el-menu-item>
					<el-menu-item index="restartRecordList"
						:class="onRoutes == 'restartRecordList' ? theme6 : ''">停复机</el-menu-item>
					<el-menu-item index="activationList"
						:class="onRoutes == 'activationList' ? theme6 : ''">限制返档</el-menu-item>
					<el-menu-item index="NoShutdownMaintenanceNumber"
						:class="onRoutes == 'NoShutdownMaintenanceNumber' ? theme6 : ''">取消停机保号</el-menu-item>
					<el-menu-item index="djRecharge" :class="onRoutes == 'djRecharge' ? theme6 : ''">迪加充值</el-menu-item>
					<el-menu-item index="djRebateList"
						:class="onRoutes == 'djRebateList' ? theme6 : ''">返销记录</el-menu-item>
					<el-menu-item index="DJAbnormalCallList"
						:class="onRoutes == 'DJAbnormalCallList' ? theme6 : ''">迪加异常话单</el-menu-item>
					<el-menu-item index="DJfreeze" :class="onRoutes == 'DJfreeze' ? theme6 : ''">自选套餐冻结</el-menu-item>
					<el-menu-item index="numberControl"
						:class="onRoutes == 'numberControl' ? theme6 : ''">漫游管控</el-menu-item>
					<el-menu-item index="accountReview"
						:class="onRoutes == 'accountReview' ? theme6 : ''">开户审核查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="CCQuery">
				<template v-slot:title>
					<i class="el-icon-postcard" :class="[
							onRoutes == 'CCQuery' ? theme3 : '',
							onRoutes == 'CCrestartRecordList' ? theme3 : '',
							onRoutes == 'WNAbnormalCallList' ? theme3 : '',
							]"></i>
					<span :class="[
							onRoutes == 'CCQuery' ? theme3 : '',
							onRoutes == 'CCrestartRecordList' ? theme3 : '',
							onRoutes == 'CCWNAbnormalCallList' ? theme3 : '',
						]">长城管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="CCQuery" :class="onRoutes == 'CCQuery' ? theme6 : ''">长城查询</el-menu-item>
					<el-menu-item index="CCrestartRecordList"
						:class="onRoutes == 'CCrestartRecordList' ? theme6 : ''">停复机</el-menu-item>
					<el-menu-item index="CCWNAbnormalCallList"
						:class="onRoutes == 'CCWNAbnormalCallList' ? theme6 : ''">异常话单</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-submenu index="userInfo" v-if="webName == '橙逸通信'">
				<template v-slot:title>
					<i class="el-icon-bank-card" :class="[
						onRoutes == 'userInfo' ? theme3 : '',
						onRoutes == 'activationList' ? theme3 : '', 
						onRoutes == 'DJAbnormalCallList' ? theme3 : '', 
						onRoutes == 'DJfreeze' ? theme3 : '', 
						onRoutes == 'numberControl' ? theme3 : '', 
						onRoutes == 'accountReview' ? theme3 : '']"></i>
					<span :class="[
						onRoutes == 'userInfo' ? theme3 : '',
						onRoutes == 'activationList' ? theme3 : '', 
						onRoutes == 'DJAbnormalCallList' ? theme3 : '', 
						onRoutes == 'DJfreeze' ? theme3 : '', 
						onRoutes == 'numberControl' ? theme3 : '', 
						onRoutes == 'accountReview' ? theme3 : '']">迪加管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="userInfo" :class="onRoutes == 'userInfo' ? theme6 : ''">迪加查询</el-menu-item>
					<el-menu-item index="activationList"
						:class="onRoutes == 'activationList' ? theme6 : ''">限制返档</el-menu-item>
					<el-menu-item index="DJAbnormalCallList"
						:class="onRoutes == 'DJAbnormalCallList' ? theme6 : ''">迪加异常话单</el-menu-item>
					<el-menu-item index="DJfreeze" :class="onRoutes == 'DJfreeze' ? theme6 : ''">自选套餐冻结</el-menu-item>
					<el-menu-item index="numberControl"
						:class="onRoutes == 'numberControl' ? theme6 : ''">漫游管控</el-menu-item>
					<el-menu-item index="accountReview"
						:class="onRoutes == 'accountReview' ? theme6 : ''">开户审核查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="tagQuery">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'tagQuery' ? theme3 : '', 
							onRoutes == 'programmeManagement' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe98f;</span>
					<span :class="[
							onRoutes == 'programmeManagement' ? theme3 : '', 
							onRoutes == 'tagQuery' ? theme3 : '']">标记查询</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="tagQuery" :class="onRoutes == 'tagQuery' ? theme6 : ''">标记查询</el-menu-item>
					<el-menu-item index="programmeManagement"
						:class="onRoutes == 'programmeManagement' ? theme6 : ''">方案管理</el-menu-item>
					<!-- <el-menu-item index="webClue" :class="onRoutes == 'webClue' ? theme6 : ''">网站线索</el-menu-item> -->
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="report">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'report' ? theme3 : '',
							onRoutes == 'companyStatistics' ? theme3 : '',
							onRoutes == 'companyStatistics' ? theme3 : '', 
							onRoutes == 'statistics' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe9b1;</span>
					<span :class="[
							onRoutes == 'report' ? theme3 : '',
							onRoutes == 'companyStatistics' ? theme3 : '',
							onRoutes == 'companyStatistics' ? theme3 : '', 
							onRoutes == 'statistics' ? theme3 : '']">统计管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="report" :class="onRoutes == 'report' ? theme6 : ''">员工统计报表</el-menu-item>
					<el-menu-item index="companyStatistics"
						:class="onRoutes == 'companyStatistics' ? theme6 : ''">公司统计报表</el-menu-item>
					<el-menu-item index="statistics" :class="onRoutes == 'statistics' ? theme6 : ''">话单校验</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="workOrder">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'woniunumberPool' ? theme3 : '',
							onRoutes == 'woniuBill' ? theme3 : '',
							onRoutes == 'shutdownRecord' ? theme3 : '',
							onRoutes == 'gmAbnormalCallList' ? theme3 : '',
							onRoutes == 'gmAbnormalNumber' ? theme3 : '',
							onRoutes == 'workOrder' ? theme3 : '',
							onRoutes == 'prestore' ? theme3 : '',
							onRoutes == 'blackNameList' ? theme3 : '',
							onRoutes == 'reportNumber' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;">
						&#xe9b5;</span>
					<span :class="[
							onRoutes == 'woniunumberPool' ? theme3 : '',
							onRoutes == 'woniuBill' ? theme3 : '',
							onRoutes == 'shutdownRecord' ? theme3 : '',
							onRoutes == 'gmAbnormalCallList' ? theme3 : '',
							onRoutes == 'gmAbnormalNumber' ? theme3 : '',
							onRoutes == 'workOrder' ? theme3 : '',
							onRoutes == 'prestore' ? theme3 : '',
							onRoutes == 'blackNameList' ? theme3 : '',
							onRoutes == 'reportNumber' ? theme3 : ''
						]">号码分类
					</span>
				</template>
				<el-menu-item-group>
					<!-- <el-menu-item index="woniunumberPool"
						:class="onRoutes == 'woniunumberPool' ? theme6 : ''">蜗牛号码池</el-menu-item>
					<el-menu-item index="woniuBill" :class="onRoutes == 'woniuBill' ? theme6 : ''">蜗牛话单</el-menu-item>
					<el-menu-item index="prestore" :class="onRoutes == 'prestore' ? theme6 : ''">蜗牛预存款</el-menu-item>
					<el-menu-item index="shutdownRecord"
						:class="onRoutes == 'shutdownRecord' ? theme6 : ''">蜗牛停机记录</el-menu-item> -->
					<!-- 	<el-menu-item index="gmAbnormalCallList"
						:class="onRoutes == 'gmAbnormalCallList' ? theme6 : ''">国美异常话单</el-menu-item>
					<el-menu-item index="gmAbnormalNumber"
						:class="onRoutes == 'gmAbnormalNumber' ? theme6 : ''">国美异常号码</el-menu-item> -->
					<el-menu-item index="workOrder" :class="onRoutes == 'workOrder' ? theme6 : ''">工单管理</el-menu-item>
					<el-menu-item index="reportNumber"
						:class="onRoutes == 'reportNumber' ? theme6 : ''">报备绿名单号码</el-menu-item>
					<el-menu-item index="blackNameList"
						:class="onRoutes == 'blackNameList' ? theme6 : ''">风险黑名单</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="telephoneInspection">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'telephoneInspectionType' ? theme3 : '',
							onRoutes == 'telephoneInspection' ? theme3 : '',
							onRoutes == 'telephoneInspectionList' ? theme3 : '',
							onRoutes == 'inspectionServer' ? theme3 : '',
							onRoutes == 'riskList2' ? theme3 : '',
							onRoutes == 'qualityInspection2' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe9a0;</span>
					<span :class="[
							onRoutes == 'telephoneInspectionType' ? theme3 : '',
							onRoutes == 'telephoneInspection' ? theme3 : '',
							onRoutes == 'telephoneInspectionList' ? theme3 : '',
							onRoutes == 'inspectionServer' ? theme3 : '',
							onRoutes == 'riskList2' ? theme3 : '',
							onRoutes == 'qualityInspection2' ? theme3 : '',
						]">通话质检
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="telephoneInspectionList"
						:class="onRoutes == 'telephoneInspectionList' ? theme6 : ''">AI质检</el-menu-item>
					<el-menu-item index="riskList2" :class="onRoutes == 'riskList2' ? theme6 : ''">风险通话列表</el-menu-item>
					<el-menu-item index="qualityInspection2"
						:class="onRoutes == 'qualityInspection2' ? theme6 : ''">录音检测</el-menu-item>
					<el-menu-item index="telephoneInspectionType"
						:class="onRoutes == 'telephoneInspectionType' ? theme6 : ''">类别管理</el-menu-item>
					<el-menu-item index="telephoneInspection"
						:class="onRoutes == 'telephoneInspection' ? theme6 : ''">关键词列表</el-menu-item>
					<el-menu-item index="inspectionServer"
						:class="onRoutes == 'inspectionServer' ? theme6 : ''">语音检测服务器</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="agent">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'woniuRecharge' ? theme3 : '',
							onRoutes == 'agent' ? theme3 : '',
							onRoutes == 'agentSerial' ? theme3 : '',
							onRoutes == 'flowManagement' ? theme3 : '',
							onRoutes == 'refundList' ? theme3 : '',
							onRoutes == 'seating' ? theme3 : '',
							onRoutes == 'userPhone' ? theme3 : '',
							onRoutes == 'remoteLogin' ? theme3 : '',
							onRoutes == 'callsNumber' ? theme3 : '',
							onRoutes == 'administratorAccount' ? theme3 : '',
							onRoutes == 'outboundCallRecords' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe99e;</span>
					<span :class="[
							onRoutes == 'woniuRecharge' ? theme3 : '',
							onRoutes == 'agent' ? theme3 : '',
							onRoutes == 'agentSerial' ? theme3 : '',
							onRoutes == 'flowManagement' ? theme3 : '',
							onRoutes == 'refundList' ? theme3 : '',
							onRoutes == 'seating' ? theme3 : '',
							onRoutes == 'userPhone' ? theme3 : '',
							onRoutes == 'remoteLogin' ? theme3 : '',
							onRoutes == 'callsNumber' ? theme3 : '',
							onRoutes == 'administratorAccount' ? theme3 : '',
							onRoutes == 'outboundCallRecords' ? theme3 : ''
						]">管理员权限
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="woniuRecharge"
						:class="onRoutes == 'woniuRecharge' ? theme6 : ''">充值列表</el-menu-item>
					<el-menu-item index="agent" :class="onRoutes == 'agent' ? theme6 : ''">代理商管理</el-menu-item>
					<el-menu-item index="administratorAccount" v-if="ms_username=='root'||ms_username=='admin'"
						:class="onRoutes == 'administratorAccount' ? theme6 : ''">管理员账号</el-menu-item>
					<el-menu-item index="agentSerial"
						:class="onRoutes == 'agentSerial' ? theme6 : ''">代理商分配记录</el-menu-item>
					<el-menu-item index="flowManagement"
						:class="onRoutes == 'flowManagement' ? theme6 : ''">流水管理</el-menu-item>
					<!-- <el-menu-item index="UUtemplate" :class="onRoutes == 'UUtemplate' ? theme6 : ''">U友模版</el-menu-item> -->
					<el-menu-item index="refundList" :class="onRoutes == 'refundList' ? theme6 : ''">退款记录</el-menu-item>
					<!-- <el-menu-item index="SJTXinventory"
						:class="onRoutes == 'SJTXinventory' ? theme6 : ''">世纪通信库存</el-menu-item> -->
					<!-- <el-menu-item index="outboundRecord"
						:class="onRoutes == 'outboundRecord' ? theme6 : ''">出库记录</el-menu-item> -->
					<!-- <el-menu-item index="inventoryList"
						:class="onRoutes == 'inventoryList' ? theme6 : ''">库存列表</el-menu-item> -->
					<!-- <el-menu-item index="inventorySetMenu"
						:class="onRoutes == 'inventorySetMenu' ? theme6 : ''">库存套餐</el-menu-item> -->
					<!-- <el-menu-item index="SJinventory"
						:class="onRoutes == 'SJinventory' ? theme6 : ''">世纪通信库存</el-menu-item> -->
					<!-- <el-menu-item index="SJDeliveryRecord"
						:class="onRoutes == 'SJDeliveryRecord' ? theme6 : ''">世纪通信库存记录</el-menu-item> -->
					<!-- <el-menu-item index="earlyWarning"
						:class="onRoutes == 'earlyWarning' ? theme6 : ''">预警规则</el-menu-item> -->
					<!-- <el-menu-item index="numberPool" :class="onRoutes == 'woniunumberPool' ? theme6 : ''">号码池</el-menu-item> -->
					<!-- <el-menu-item index="stopPhone" :class="onRoutes == 'woniunumberPool' ? theme6 : ''">号码停机</el-menu-item> -->
					<el-menu-item index="seating" :class="onRoutes == 'seating' ? theme6 : ''">坐席数据</el-menu-item>
					<el-menu-item index="userPhone" :class="onRoutes == 'userPhone' ? theme6 : ''">账号登录记录</el-menu-item>
					<el-menu-item index="callsNumber"
						:class="onRoutes == 'callsNumber' ? theme6 : ''">电话邦放行次数</el-menu-item>
					<el-menu-item index="outboundCallRecords"
						:class="onRoutes == 'outboundCallRecords' ? theme6 : ''">外呼记录</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="cardType">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'cardType' ? theme3 : '',
							onRoutes == 'blackListDatabase' ? theme3 : '',
							onRoutes == 'userSerial' ? theme3 : '',
							onRoutes == 'role' ? theme3 : '',
							onRoutes == 'operationLog' ? theme3 : '',
							onRoutes == 'termOfValidity' ? theme3 : '',
							onRoutes == 'subagent' ? theme3 : '',
							onRoutes == 'businessRecords' ? theme3 : '',
							onRoutes == 'deleteRecords' ? theme3 : '',
							onRoutes == 'setColor' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe990;</span>
					<span :class="[
							onRoutes == 'cardType' ? theme3 : '',
							onRoutes == 'blackListDatabase' ? theme3 : '',
							onRoutes == 'userSerial' ? theme3 : '',
							onRoutes == 'role' ? theme3 : '',
							onRoutes == 'operationLog' ? theme3 : '',
							onRoutes == 'termOfValidity' ? theme3 : '',
							onRoutes == 'subagent' ? theme3 : '',
							onRoutes == 'businessRecords' ? theme3 : '',
							onRoutes == 'deleteRecords' ? theme3 : '',
							onRoutes == 'setColor' ? theme3 : ''
						]">系统设置
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="cardType" :class="onRoutes == 'cardType' ? theme6 : ''">品牌管理</el-menu-item>
					<el-menu-item index="subagent" :class="onRoutes == 'subagent' ? theme6 : ''">子代理列表</el-menu-item>
					<!-- //在领尚注释!-->
					<!-- <el-menu-item index="blackListDatabase" :class="onRoutes == 'blackListDatabase' ? theme6 : ''">黑名单库</el-menu-item> -->
					<!-- <el-menu-item index="userSerial" :class="onRoutes == 'userSerial' ? theme6 : ''">员工分配记录</el-menu-item> -->
					<el-menu-item index="role" :class="onRoutes == 'role' ? theme6 : ''">角色管理</el-menu-item>
					<!-- //在领尚注释!-->
					<el-menu-item index="operationLog"
						:class="onRoutes == 'operationLog' ? theme6 : ''">员工操作日志</el-menu-item>
					<el-menu-item index="termOfValidity"
						:class="onRoutes == 'termOfValidity' ? theme6 : ''">有效期管理</el-menu-item>
					<el-menu-item index="businessRecords"
						:class="onRoutes == 'businessRecords' ? theme6 : ''">业务记录</el-menu-item>
					<el-menu-item index="deleteRecords"
						:class="onRoutes == 'deleteRecords' ? theme6 : ''">删除记录</el-menu-item>
					<el-menu-item index="setColor" :class="onRoutes == 'setColor' ? theme6 : ''">设置主题</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="advancedSearch" v-if="CY">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;">
						&#xe99c;</span>
					<span :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : ''
						]">
						寻迹通
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="advancedSearch"
						:class="onRoutes == 'advancedSearch' ? theme6 : ''">找线索</el-menu-item>
					<el-menu-item index="companySearch"
						:class="onRoutes == 'companySearch' ? theme6 : ''">找企业</el-menu-item>
					<el-menu-item index="shopSearch" :class="onRoutes == 'shopSearch' ? theme6 : ''">找店铺</el-menu-item>
					<el-menu-item index="industryTemplate"
						:class="onRoutes == 'industryTemplate' ? theme6 : ''">找行业</el-menu-item>
					<el-menu-item index="mapSearch" :class="onRoutes == 'mapSearch' ? theme6 : ''">地图找客</el-menu-item>
					<el-menu-item index="batchCheckCompany"
						:class="onRoutes == 'batchCheckCompany' ? theme6 : ''">批量查询</el-menu-item>
					<el-menu-item index="poolAccount"
						:class="onRoutes == 'poolAccount' ? theme6 : ''">账号管理</el-menu-item>
					<el-menu-item-group><el-menu-item index="highSeas"
							:class="onRoutes == 'highSeas' ? theme6 : ''">数据池</el-menu-item></el-menu-item-group>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="panelData">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'SJTXinventory' ? theme3 : '',
							onRoutes == 'outboundRecord' ? theme3 : '',
							onRoutes == 'purchaseOrderList' ? theme3 : '',
							onRoutes == 'whiteCard' ? theme3 : '',
							onRoutes == 'inventoryList' ? theme3 : '',
							onRoutes == 'inventorySetMenu' ? theme3 : '',
							onRoutes == 'SJinventory' ? theme3 : '',
							onRoutes == 'SJDeliveryRecord' ? theme3 : '',
							onRoutes == 'earlyWarning' ? theme3 : '',
							onRoutes == 'frequencyLimiting' ? theme3 : '',
						]" style="font-size:16px !important;margin-right:10px !important;">
						&#xe9bc;</span>
					<span :class="[
							onRoutes == 'SJTXinventory' ? theme3 : '',
							onRoutes == 'outboundRecord' ? theme3 : '',
							onRoutes == 'purchaseOrderList' ? theme3 : '',
							onRoutes == 'whiteCard' ? theme3 : '',
							onRoutes == 'inventoryList' ? theme3 : '',
							onRoutes == 'inventorySetMenu' ? theme3 : '',
							onRoutes == 'SJinventory' ? theme3 : '',
							onRoutes == 'SJDeliveryRecord' ? theme3 : '',
							onRoutes == 'earlyWarning' ? theme3 : '',
							onRoutes == 'frequencyLimiting' ? theme3 : '',
						]">库存管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="SJTXinventory"
						:class="onRoutes == 'SJTXinventory' ? theme6 : ''">库存面板</el-menu-item>
					<el-menu-item index="purchaseOrderList"
						:class="onRoutes == 'purchaseOrderList' ? theme6 : ''">采购列表</el-menu-item>
					<el-menu-item index="whiteCard" :class="onRoutes == 'whiteCard' ? theme6 : ''">白卡列表</el-menu-item>
					<el-menu-item index="outboundRecord"
						:class="onRoutes == 'outboundRecord' ? theme6 : ''">出库记录</el-menu-item>
					<el-menu-item index="inventoryList"
						:class="onRoutes == 'inventoryList' ? theme6 : ''">库存列表</el-menu-item>

					<el-menu-item index="inventorySetMenu"
						:class="onRoutes == 'inventorySetMenu' ? theme6 : ''">库存套餐</el-menu-item>
					<el-menu-item index="earlyWarning"
						:class="onRoutes == 'earlyWarning' ? theme6 : ''">预警规则</el-menu-item>
					<el-menu-item index="frequencyLimiting"
						:class="onRoutes == 'frequencyLimiting' ? theme6 : ''">出库限频</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="trumpetTemplate">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'trumpetTemplate' ? theme3 : '',
							onRoutes == 'tonglianPrecisionTube' ? theme3 : '',
							onRoutes == 'trumpetenterpriseAllocation' ? theme3 : '',
							onRoutes == 'trumpetspecialServiceNumber' ? theme3 : '',
							onRoutes == 'SIPServer' ? theme3 : '',
							onRoutes == 'premium' ? theme3 : '',
							onRoutes == 'trumpetFTConsumptionDetails' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;">
						&#xe9c2;</span>
					<span :class="[
							onRoutes == 'trumpetTemplate' ? theme3 : '',
							onRoutes == 'tonglianPrecisionTube' ? theme3 : '',
							onRoutes == 'trumpetenterpriseAllocation' ? theme3 : '',
							onRoutes == 'trumpetspecialServiceNumber' ? theme3 : '',
							onRoutes == 'SIPServer' ? theme3 : '',
							onRoutes == 'premium' ? theme3 : '',
							onRoutes == 'trumpetFTConsumptionDetails' ? theme3 : '',
						]">云呼管理
					</span>


				</template>
				<el-menu-item-group>
					<el-menu-item index="tonglianPrecisionTube"
						:class="onRoutes == 'tonglianPrecisionTube' ? theme6 : ''">云呼面板</el-menu-item>
					<el-menu-item index="trumpetTemplate"
						:class="onRoutes == 'trumpetTemplate' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="trumpetenterpriseAllocation"
						:class="onRoutes == 'trumpetenterpriseAllocation' ? theme6 : ''">企业套餐</el-menu-item>
					<el-menu-item index="trumpetspecialServiceNumber"
						:class="onRoutes == 'trumpetspecialServiceNumber' ? theme6 : ''">号码状态</el-menu-item>
					<el-menu-item index="trumpetFTConsumptionDetails"
						:class="onRoutes == 'trumpetFTConsumptionDetails' ? theme6 : ''">账单明细</el-menu-item>
					<el-menu-item index="premium" :class="onRoutes == 'premium' ? theme6 : ''">溢价</el-menu-item>
					<el-menu-item index="SIPServer" :class="onRoutes == 'SIPServer' ? theme6 : ''">云呼服务器</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

<!--      <el-submenu index="testTem">-->
<!--        <template v-slot:title>-->
<!--					<span class="icon iconfont" :class="[-->
<!--              onRoutes == 'testTem' ? theme3 : '',-->
<!--							onRoutes == 'NewPage' ? theme3 : '',-->
<!--						]" style="font-size:16px !important;margin-right:10px !important;">-->
<!--						&#xe6de;</span>-->

<!--          <span :class="[-->
<!--							onRoutes == 'NewPage' ? theme3 : '',-->
<!--						]">测试-->
<!--					</span>-->


<!--        </template>-->
<!--        <el-menu-item-group>-->
<!--          <el-menu-item index="NewPage"-->
<!--                        :class="onRoutes == 'NewPage' ? theme3 : ''">测试页面</el-menu-item>-->
<!--        </el-menu-item-group>-->
<!--      </el-submenu>-->
			<!-- <el-submenu index="cdrBatchManagement">
				<template v-slot:title>
					<i class="el-icon-box" :class="[
						onRoutes == 'cdrBatchAllocation' ? theme3 : '',
						onRoutes == 'cdrBatchConsumptionDetails' ? theme3 : '',
						onRoutes == 'cdrBatchList' ? theme3 : '',
						onRoutes == 'cdrBatchManagement' ? theme3 : '',
						onRoutes == 'cdrBatchPremium' ? theme3 : '',
						onRoutes == 'cdrBatchServer' ? theme3 : '',
						onRoutes == 'cdrBatchType' ? theme3 : '',]"></i>
					<span :class="[
							onRoutes == 'cdrBatchAllocation' ? theme3 : '',
							onRoutes == 'cdrBatchConsumptionDetails' ? theme3 : '',
							onRoutes == 'cdrBatchList' ? theme3 : '',
							onRoutes == 'cdrBatchManagement' ? theme3 : '',
							onRoutes == 'cdrBatchPremium' ? theme3 : '',
							onRoutes == 'cdrBatchServer' ? theme3 : '',
							onRoutes == 'cdrBatchType' ? theme3 : '',
						]">话批管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="cdrBatchManagement"
						:class="onRoutes == 'cdrBatchManagement' ? theme6 : ''">话批面板</el-menu-item>
					<el-menu-item index="cdrBatchList"
						:class="onRoutes == 'cdrBatchList' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="cdrBatchAllocation"
						:class="onRoutes == 'cdrBatchAllocation' ? theme6 : ''">企业套餐</el-menu-item>
					<el-menu-item index="cdrBatchType"
						:class="onRoutes == 'cdrBatchType' ? theme6 : ''">号码状态</el-menu-item>
					<el-menu-item index="cdrBatchConsumptionDetails"
						:class="onRoutes == 'cdrBatchConsumptionDetails' ? theme6 : ''">账单明细</el-menu-item>
					<el-menu-item index="cdrBatchPremium"
						:class="onRoutes == 'cdrBatchPremium' ? theme6 : ''">溢价</el-menu-item>
					<el-menu-item index="cdrBatchServer"
						:class="onRoutes == 'cdrBatchServer' ? theme6 : ''">话批品牌</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<!-- 
			<el-submenu index="packageManagementX">
				<template v-slot:title>
					<i class="el-icon-connection" :class="[
							onRoutes == 'packageManagementX' ? theme3 : '',
							onRoutes == 'packageManagementXuser' ? theme3 : '',
							onRoutes == 'hySA' ? theme3 : '',
							onRoutes == 'AXBBinding' ? theme3 : '',
							onRoutes == 'record2' ? theme3 : '',
						]"></i>
					<span :class="[
							onRoutes == 'packageManagementX' ? theme3 : '',
							onRoutes == 'packageManagementXuser' ? theme3 : '',
							onRoutes == 'hySA' ? theme3 : '',
							onRoutes == 'AXBBinding' ? theme3 : '',
							onRoutes == 'record2' ? theme3 : '',
						]">虚商SAXB
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="packageManagementX"
						:class="onRoutes == 'packageManagementX' ? theme6 : ''">套餐管理</el-menu-item>
					<el-menu-item index="packageManagementXuser"
						:class="onRoutes == 'packageManagementXuser' ? theme6 : ''">用户管理</el-menu-item>
					<el-menu-item index="hySA" :class="onRoutes == 'hySA' ? theme6 : ''">华云SA套餐用量查询</el-menu-item>
					<el-menu-item index="AXBBinding" :class="onRoutes == 'AXBBinding' ? theme6 : ''">绑定查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<!-- <el-submenu index="packageManagement" v-if="CY">
				<template v-slot:title>
					<i class="el-icon-guide" :class="[
							onRoutes == 'packageManagement' ? theme3 : '',
							onRoutes == 'AXBinventory' ? theme3 : '',
							onRoutes == 'purchaseList' ? theme3 : '',
							onRoutes == 'consultationDetailed' ? theme3 : ''
						]"></i>
					<span :class="[
							onRoutes == 'packageManagement' ? theme3 : '',
							onRoutes == 'AXBinventory' ? theme3 : '',
							onRoutes == 'purchaseList' ? theme3 : '',
							onRoutes == 'consultationDetailed' ? theme3 : ''
						]">AXB
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="packageManagement"
						:class="onRoutes == 'packageManagement' ? theme6 : ''">套餐管理</el-menu-item>
					<el-menu-item index="AXBinventory"
						:class="onRoutes == 'AXBinventory' ? theme6 : ''">AXB库存</el-menu-item>
					<el-menu-item index="purchaseList"
						:class="onRoutes == 'purchaseList' ? theme6 : ''">已购号码</el-menu-item>
					<el-menu-item index="consultationDetailed"
						:class="onRoutes == 'consultationDetailed' ? theme6 : ''">消费明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-submenu index="packageList">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'packageList' ? theme3 : '',
							onRoutes == 'middleNumber' ? theme3 : '',
							onRoutes == 'consumptionDetails' ? theme3 : '',
							onRoutes == 'privateNumber' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe9b7;</span>
					<span :class="[
							onRoutes == 'packageList' ? theme3 : '',
							onRoutes == 'middleNumber' ? theme3 : '',
							onRoutes == 'consumptionDetails' ? theme3 : '',
							onRoutes == 'privateNumber' ? theme3 : '']">回拨管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="packageList"
						:class="onRoutes == 'packageList' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="middleNumber"
						:class="onRoutes == 'middleNumber' ? theme6 : ''">回拨中间号</el-menu-item>
					<el-menu-item index="consumptionDetails"
						:class="onRoutes == 'consumptionDetails' ? theme6 : ''">消费明细</el-menu-item>
					<el-menu-item index="privateNumber"
						:class="onRoutes == 'privateNumber' ? theme6 : ''">私人号码</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<!-- 	<el-menu-item index="validate" :class="onRoutes == 'validate' ? theme3 : ''">
				<i class="el-icon-finished"></i>
				<span>号码验证</span>
			</el-menu-item> -->

			<el-submenu index="notice">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'notice' ? theme3 : '', 
							onRoutes == 'addNotice' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe989;</span>
					<span
						:class="[onRoutes == 'notice' ? theme3 : '', onRoutes == 'addNotice' ? theme3 : '']">公告管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="notice" :class="onRoutes == 'notice' ? theme6 : ''">公告列表</el-menu-item>
					<el-menu-item index="addNotice" :class="onRoutes == 'addNotice' ? theme6 : ''">发布公告</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="OEMset">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'OEMset' ? theme3 : '', 
							onRoutes == 'OEMswiper' ? theme3 : '', 
							onRoutes == 'swipes' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe998;</span>
					<span :class="[
							onRoutes == 'OEMset' ? theme3 : '', 
							onRoutes == 'OEMswiper' ? theme3 : '', 
							onRoutes == 'swipes' ? theme3 : '']">OEM管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="OEMset" :class="onRoutes == 'OEMset' ? theme6 : ''">OEM设置</el-menu-item>
					<el-menu-item index="OEMswiper" :class="onRoutes == 'OEMswiper' ? theme6 : ''">登录轮播图</el-menu-item>
					<el-menu-item index="swipes" :class="onRoutes == 'swipes' ? theme6 : ''">APP轮播图</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="blackList" :class="onRoutes == 'blackList' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'blackList' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98b;</span>
				<span>黑名单</span>
			</el-menu-item>
			<el-menu-item index="afterSales" :class="onRoutes == 'afterSales' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'afterSales' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe991;</span>
				<span>售后信息</span>
			</el-menu-item>
			<el-menu-item index="operationManual" v-if="webName == '云企通'"
				:class="onRoutes == 'operationManual' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<el-menu-item index="operationManual2" v-if="webName == '橙逸通信'"
				:class="onRoutes == 'operationManual2' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual2' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<div class="login_info" v-if="collapse == false">
				<div>最后登录时间:{{ lastLoginAt }}</div>
			</div>
		</el-menu>
		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router
			v-else-if="role == 'agent'">
			<el-menu-item index="dashboard" :class="onRoutes == 'dashboard' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'dashboard' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">&#xe6af;</span>
				<span>系统首页</span>
			</el-menu-item>
			<el-submenu index="advancedSearch" v-if="CY">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe99c;</span>
					<span :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : ''
						]">寻迹通
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="advancedSearch"
						:class="onRoutes == 'advancedSearch' ? theme6 : ''">找线索</el-menu-item>
					<el-menu-item index="companySearch"
						:class="onRoutes == 'companySearch' ? theme6 : ''">找企业</el-menu-item>
					<el-menu-item index="shopSearch" :class="onRoutes == 'shopSearch' ? theme6 : ''">找店铺</el-menu-item>
					<el-menu-item index="industryTemplate"
						:class="onRoutes == 'industryTemplate' ? theme6 : ''">找行业</el-menu-item>
					<el-menu-item index="mapSearch" :class="onRoutes == 'mapSearch' ? theme6 : ''">地图找客</el-menu-item>
					<el-menu-item index="batchCheckCompany"
						:class="onRoutes == 'batchCheckCompany' ? theme6 : ''">批量查询</el-menu-item>
					<el-menu-item index="poolAccount"
						:class="onRoutes == 'poolAccount' ? theme6 : ''">账号管理</el-menu-item>
					<el-menu-item-group><el-menu-item index="highSeas"
							:class="onRoutes == 'highSeas' ? theme6 : ''">数据池</el-menu-item></el-menu-item-group>
				</el-menu-item-group>
			</el-submenu>

			<!-- <el-submenu index="AXBinventory">
				<template v-slot:title>
					<i class="el-icon-guide"
						:class="[onRoutes == 'AXBinventory' ? theme3 : '', onRoutes == 'purchaseList' ? theme3 : '', onRoutes == 'consultationDetailed' ? theme3 : '']"></i>
					<span
						:class="[onRoutes == 'AXBinventory' ? theme3 : '', onRoutes == 'purchaseList' ? theme3 : '', onRoutes == 'consultationDetailed' ? theme3 : '']">AXB</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="AXBinventory"
						:class="onRoutes == 'AXBinventory' ? theme6 : ''">AXB库存</el-menu-item>
					<el-menu-item index="purchaseList"
						:class="onRoutes == 'purchaseList' ? theme6 : ''">已购号码</el-menu-item>
					<el-menu-item index="consultationDetailed"
						:class="onRoutes == 'consultationDetailed' ? theme6 : ''">消费明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<!-- <el-submenu index="packageList">
				<template v-slot:title>
							<span class="icon iconfont" :class="[
														onRoutes == 'packageList' ? theme3 : '',
														onRoutes == 'middleNumber' ? theme3 : '',
														onRoutes == 'consumptionDetails' ? theme3 : '',
														onRoutes == 'privateNumber' ? theme3 : ''
												]" style="font-size:16px !important;margin-right:10px !important;">
								&#xe9b7;</span>
					<span :class="[
							onRoutes == 'packageList' ? theme3 : '',
							monRoutes == 'middleNumber' ? theme3 : '',
							monRoutes == 'privateNumber' ? theme3 : '',
							monRoutes == 'consumptionDetails' ? theme3 : '']">回拨管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="packageList"
						:class="onRoutes == 'packageList' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="middleNumber"
						:class="onRoutes == 'middleNumber' ? theme6 : ''">回拨中间号</el-menu-item>
					<el-menu-item index="consumptionDetails"
						:class="onRoutes == 'consumptionDetails' ? theme6 : ''">消费明细</el-menu-item>
					<el-menu-item index="privateNumber"
						:class="onRoutes == 'privateNumber' ? theme6 : ''">私人号码</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->


			<el-submenu index="customer">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'automaticRecycling' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'modou' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;">&#xe645;</span>
					<span :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'automaticRecycling' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'modou' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]">CRM管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="CRMstatistics"
						:class="onRoutes == 'CRMstatistics' ? theme6 : ''">统计管理</el-menu-item>
					<el-menu-item index="customer" :class="onRoutes == 'customer' ? theme6 : ''">我的客户</el-menu-item>
					<el-menu-item index="CRMHigh" :class="onRoutes == 'CRMHigh' ? theme6 : ''">公海客户</el-menu-item>
					<!-- <el-menu-item index="CRMDepartmentHigh"
						:class="onRoutes == 'CRMDepartmentHigh' ? theme6 : ''">部门公海</el-menu-item> -->
					<el-menu-item index="customTag" :class="onRoutes == 'customTag' ? theme6 : ''">字段配置</el-menu-item>
					<el-menu-item index="followProgress"
						:class="onRoutes == 'followProgress' ? theme6 : ''">跟进阶段配置</el-menu-item>
					<el-menu-item index="CRMsource" :class="onRoutes == 'CRMsource' ? theme6 : ''">来源配置</el-menu-item>
					<el-menu-item index="release" :class="onRoutes == 'release' ? theme6 : ''">释放管理</el-menu-item>
					<el-menu-item index="automaticRecycling"
						:class="onRoutes == 'automaticRecycling' ? theme6 : ''">自动回收</el-menu-item>
					<el-menu-item index="tag" :class="onRoutes == 'tag' ? theme6 : ''">标签管理</el-menu-item>
					<el-menu-item index="modou" :class="onRoutes == 'modou' ? theme6 : ''">模版管理</el-menu-item>
					<el-menu-item index="clueCollection"
						:class="onRoutes == 'clueCollection' ? theme6 : ''">领取记录</el-menu-item>
					<el-menu-item index="operationRecord"
						:class="onRoutes == 'operationRecord' ? theme6 : ''">操作记录</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="clue">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'clue' ? theme3 : '', 
							onRoutes == 'assignLeads' ? theme3 : '', 
							onRoutes == 'groupCall' ? theme3 : '', 
							onRoutes == 'cluePool' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;font-weight: 600;">&#xe738;</span>
					<span :class="[
							onRoutes == 'clue' ? theme3 : '', 
							onRoutes == 'assignLeads' ? theme3 : '', 
							onRoutes == 'groupCall' ? theme3 : '', 
							onRoutes == 'cluePool' ? theme3 : '']">线索管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="clue" :class="onRoutes == 'clue' ? theme6 : ''">线索列表</el-menu-item>
					<!-- <el-menu-item index="groupCall" :class="onRoutes == 'groupCall' ? theme6 : ''">群呼列表</el-menu-item> -->
					<el-menu-item index="assignLeads"
						:class="onRoutes == 'assignLeads' ? theme6 : ''">线索回收</el-menu-item>
					<el-menu-item index="cluePool" :class="onRoutes == 'cluePool' ? theme6 : ''">线索池</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="company">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'company' ? theme3 : '', 
							onRoutes == 'department' ? theme3 : '',
							onRoutes == 'user' ? theme3 : '', 
							onRoutes == 'addressErrList' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">&#xe818;</span>
					<span :class="[
							onRoutes == 'company' ? theme3 : '', 
							onRoutes == 'department' ? theme3 : '', 
							onRoutes == 'user' ? theme3 : '', 
							onRoutes == 'addressErrList' ? theme3 : '']">企业管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="company" :class="onRoutes == 'company' ? theme6 : ''">企业列表</el-menu-item>
					<el-menu-item index="department" :class="onRoutes == 'department' ? theme6 : ''">部门管理</el-menu-item>
					<el-menu-item index="user" :class="onRoutes == 'user' ? theme6 : ''">员工管理</el-menu-item>
					<el-menu-item index="addressErrList"
						:class="onRoutes == 'addressErrList' ? theme6 : ''">位置异常</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="record" :class="onRoutes == 'record' ? theme3 : ''">
				<span class="icon iconfont" :class="[onRoutes == 'record' ? theme3 : '']"
					style="font-size:16px !important;margin-right:10px !important;font-weight: 600;;">&#xe64b;</span>
				<span>通话记录</span>
			</el-menu-item>
			<el-menu-item index="cjabnormalCall" :class="onRoutes == 'cjabnormalCall' ? theme3 : ''"
				v-if="webName == '橙逸通信'">
				<i class="el-icon-s-shop"></i>
				<span>长江异常话单</span>
			</el-menu-item>
			<el-menu-item index="reportNumber" :class="onRoutes == 'reportNumber' ? theme3 : ''"
				v-if="webName == '橙逸通信'">
				<span class="icon iconfont" :class="onRoutes == 'reportNumber' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe9b5;</span>
				<span>报备绿名单号码</span>
			</el-menu-item>
			<el-submenu index="wnQueryCY" v-if="webName == '橙逸通信'">
				<template v-slot:title>
					<i class="el-icon-news" :class="[
						onRoutes == 'wnQueryCY' ? theme3 : '',
						onRoutes == 'WNrestartRecordListCY' ? theme3 : '',
						onRoutes == 'accountOpeningProgressCY' ? theme3 : '',
						onRoutes == 'frequencyLimitCY' ? theme3 : '',
						onRoutes == 'WNAbnormalCallListCY' ? theme3 : '',
						onRoutes == 'WNWhitelistCY' ? theme3 : '',
						onRoutes == 'batchAccountClosureCY' ? theme3 : '',
						]"></i>
					<span :class="[
							onRoutes == 'wnQueryCY' ? theme3 : '',
							onRoutes == 'WNrestartRecordListCY' ? theme3 : '',
							onRoutes == 'accountOpeningProgressCY' ? theme3 : '',
							onRoutes == 'frequencyLimitCY' ? theme3 : '',
							onRoutes == 'WNAbnormalCallListCY' ? theme3 : '',
							onRoutes == 'WNWhitelistCY' ? theme3 : '',
							onRoutes == 'batchAccountClosureCY' ? theme3 : '',
						]">CY蜗牛管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="wnQueryCY" :class="onRoutes == 'wnQueryCY' ? theme6 : ''">CY蜗牛查询</el-menu-item>
					<el-menu-item index="WNrestartRecordListCY"
						:class="onRoutes == 'WNrestartRecordListCY' ? theme6 : ''">CY停复机</el-menu-item>
					<el-menu-item index="accountOpeningProgressCY"
						:class="onRoutes == 'accountOpeningProgressCY' ? theme6 : ''">CY开户进度</el-menu-item>
					<el-menu-item index="frequencyLimitCY"
						:class="onRoutes == 'frequencyLimitCY' ? theme6 : ''">CY呼叫限频</el-menu-item>
					<el-menu-item index="WNAbnormalCallListCY"
						:class="onRoutes == 'WNAbnormalCallListCY' ? theme6 : ''">CY异常话单</el-menu-item>
					<el-menu-item index="WNWhitelistCY"
						:class="onRoutes == 'WNWhitelistCY' ? theme6 : ''">CY批量加白</el-menu-item>
					<el-menu-item index="batchAccountClosureCY"
						:class="onRoutes == 'batchAccountClosureCY' ? theme6 : ''">CY批量销户</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="wnQuery" v-if="webName == '橙逸通信'">
				<template v-slot:title>
					<i class="el-icon-discount" :class="[
						onRoutes == 'wnQuery' ? theme3 : '',
						onRoutes == 'WNAbnormalCallList' ? theme3 : '']"></i>
					<span
						:class="[ onRoutes == 'WNAbnormalCallList' ? theme3 : '', onRoutes == 'wnQuery' ? theme3 : '']">蜗牛管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="wnQuery" :class="onRoutes == 'wnQuery' ? theme6 : ''">蜗牛查询</el-menu-item>
					<el-menu-item index="WNAbnormalCallList"
						:class="onRoutes == 'WNAbnormalCallList' ? theme6 : ''">异常话单</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="userInfo" v-if="webName == '橙逸通信'">
				<template v-slot:title>
					<i class="el-icon-bank-card" :class="[onRoutes == 'userInfo' ? theme3 : '',
						onRoutes == 'activationList' ? theme3 : '', 
						onRoutes == 'DJAbnormalCallList' ? theme3 : '', 
						onRoutes == 'DJfreeze' ? theme3 : '', 
						onRoutes == 'numberControl' ? theme3 : '', 
						onRoutes == 'accountReview' ? theme3 : '']"></i>
					<span :class="[onRoutes == 'userInfo' ? theme3 : '',
						onRoutes == 'activationList' ? theme3 : '', 
						onRoutes == 'DJAbnormalCallList' ? theme3 : '', 
						onRoutes == 'DJfreeze' ? theme3 : '', 
						onRoutes == 'numberControl' ? theme3 : '', 
						onRoutes == 'accountReview' ? theme3 : '']">迪加管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="userInfo" :class="onRoutes == 'userInfo' ? theme6 : ''">迪加查询</el-menu-item>
					<el-menu-item index="activationList"
						:class="onRoutes == 'activationList' ? theme6 : ''">限制返档</el-menu-item>
					<el-menu-item index="DJAbnormalCallList"
						:class="onRoutes == 'DJAbnormalCallList' ? theme6 : ''">迪加异常话单</el-menu-item>
					<el-menu-item index="DJfreeze" :class="onRoutes == 'DJfreeze' ? theme6 : ''">自选套餐冻结</el-menu-item>
					<el-menu-item index="numberControl"
						:class="onRoutes == 'numberControl' ? theme6 : ''">漫游管控</el-menu-item>
					<el-menu-item index="accountReview"
						:class="onRoutes == 'accountReview' ? theme6 : ''">开户审核查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu>


			<el-submenu index="telephoneInspection">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'telephoneInspectionType' ? theme3 : '',
							onRoutes == 'telephoneInspection' ? theme3 : '',
							onRoutes == 'telephoneInspectionList' ? theme3 : '',
							onRoutes == 'inspectionServer' ? theme3 : '',
							onRoutes == 'riskList2' ? theme3 : '',
							onRoutes == 'qualityInspection2' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe9a0;</span>
					<span :class="[
							onRoutes == 'telephoneInspectionType' ? theme3 : '',
							onRoutes == 'telephoneInspection' ? theme3 : '',
							onRoutes == 'telephoneInspectionList' ? theme3 : '',
							onRoutes == 'inspectionServer' ? theme3 : '',
							onRoutes == 'riskList2' ? theme3 : '',
							onRoutes == 'qualityInspection2' ? theme3 : '',
						]">通话质检
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="telephoneInspectionList"
						:class="onRoutes == 'telephoneInspectionList' ? theme6 : ''">AI质检</el-menu-item>
					<el-menu-item index="riskList2" :class="onRoutes == 'riskList2' ? theme6 : ''">风险通话列表</el-menu-item>
					<el-menu-item index="qualityInspection2"
						:class="onRoutes == 'qualityInspection2' ? theme6 : ''">录音检测</el-menu-item>
					<el-menu-item index="telephoneInspectionType"
						:class="onRoutes == 'telephoneInspectionType' ? theme6 : ''">类别管理</el-menu-item>
					<el-menu-item index="telephoneInspection"
						:class="onRoutes == 'telephoneInspection' ? theme6 : ''">关键词列表</el-menu-item>
					<el-menu-item index="inspectionServer"
						:class="onRoutes == 'inspectionServer' ? theme6 : ''">语音检测服务器</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="WNvirtualCommerce">
				<template v-slot:title>
					<span class="icon iconfont" :class="[onRoutes == 'GMvirtualCommerce' ? theme3 : '',
							onRoutes == 'WNvirtualCommerce' ? theme3 : '',
							onRoutes == 'DJvirtualCommerce' ? theme3 : '',
							onRoutes == 'CCvirtualCommerce' ? theme3 : '',]"
						style="font-size:16px !important;margin-right:10px !important;">&#xe98a;</span>
					<span :class="[
							onRoutes == 'GMvirtualCommerce' ? theme3 : '',
							onRoutes == 'WNvirtualCommerce' ? theme3 : '',
							onRoutes == 'DJvirtualCommerce' ? theme3 : '',
							onRoutes == 'CCvirtualCommerce' ? theme3 : '',
							]">虚商管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="WNvirtualCommerce"
						:class="onRoutes == 'WNvirtualCommerce' ? theme6 : ''">蜗牛管理</el-menu-item>
					<el-menu-item index="DJvirtualCommerce"
						:class="onRoutes == 'DJvirtualCommerce' ? theme6 : ''">迪加管理</el-menu-item>
					<el-menu-item index="GMvirtualCommerce"
						:class="onRoutes == 'GMvirtualCommerce' ? theme6 : ''">国美管理</el-menu-item>
					<el-menu-item index="CCvirtualCommerce"
						:class="onRoutes == 'CCvirtualCommerce' ? theme6 : ''">长城管理</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<!-- <el-submenu index="wnQuery" v-if="webName == '云企通'">
				<template v-slot:title>
					<i class="el-icon-discount" :class="[
						onRoutes == 'wnQuery' ? theme3 : '',
						onRoutes == 'WNAbnormalCallList' ? theme3 : '',
						]"></i>
					<span
						:class="[onRoutes == 'WNAbnormalCallList' ? theme3 : '', onRoutes == 'wnQuery' ? theme3 : '']">蜗牛管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="wnQuery" :class="onRoutes == 'wnQuery' ? theme6 : ''">蜗牛查询</el-menu-item>
					<el-menu-item index="WNAbnormalCallList"
						:class="onRoutes == 'WNAbnormalCallList' ? theme6 : ''">异常话单</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<!-- <el-submenu index="userInfo" v-if="webName == '云企通'">
				<template v-slot:title>
					<i class="el-icon-bank-card" :class="[onRoutes == 'userInfo' ? theme3 : '',
						 onRoutes == 'activationList' ? theme3 : '', 
						 onRoutes == 'DJAbnormalCallList' ? theme3 : '', 
						 onRoutes == 'DJfreeze' ? theme3 : '', 
						 onRoutes == 'numberControl' ? theme3 : '', 
						 onRoutes == 'accountReview' ? theme3 : '']"></i>
					<span :class="[
							onRoutes == 'userInfo' ? theme3 : '',
							onRoutes == 'activationList' ? theme3 : '',
							onRoutes == 'DJAbnormalCallList' ? theme3 : '',
							onRoutes == 'DJfreeze' ? theme3 : '',
							onRoutes == 'numberControl' ? theme3 : '',
							onRoutes == 'accountReview' ? theme3 : ''
						]">迪加管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="userInfo" :class="onRoutes == 'userInfo' ? theme6 : ''">迪加查询</el-menu-item>
					<el-menu-item index="activationList"
						:class="onRoutes == 'activationList' ? theme6 : ''">限制返档</el-menu-item>
					<el-menu-item index="DJAbnormalCallList"
						:class="onRoutes == 'DJAbnormalCallList' ? theme6 : ''">迪加异常话单</el-menu-item>
					<el-menu-item index="DJfreeze" :class="onRoutes == 'DJfreeze' ? theme6 : ''">自选套餐冻结</el-menu-item>
					<el-menu-item index="numberControl"
						:class="onRoutes == 'numberControl' ? theme6 : ''">漫游管控</el-menu-item>
					<el-menu-item index="accountReview"
						:class="onRoutes == 'accountReview' ? theme6 : ''">开户审核查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-submenu index="addReturns" v-if="webName == '云企通'">
				<template v-slot:title>
					<span class="icon iconfont" :class="onRoutes == 'addReturns' ? theme3 : ''"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe98f;</span>
					<span :class="onRoutes == 'addReturns' ? theme3 : ''">充值管理</span>
				</template>
				<el-menu-item-group><el-menu-item index="addReturns"
						:class="onRoutes == 'addReturns' ? theme6 : ''">蜗牛充值</el-menu-item></el-menu-item-group>
			</el-submenu>
			<el-submenu index="tagQuery">
				<template v-slot:title>
					<span class="icon iconfont" :class="[onRoutes == 'tagQuery' ? theme3 : '' ]"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe98f;</span>
					<span :class="[onRoutes == 'tagQuery' ? theme3 : '']">标记查询</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="tagQuery" :class="onRoutes == 'tagQuery' ? theme6 : '' ">标记查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="report">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'report' ? theme3 : '',
							onRoutes == 'report' ? theme3 : '',
							onRoutes == 'companyStatistics' ? theme3 : '', 
							onRoutes == 'seating' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe9b1;</span>
					<span :class="[
							onRoutes == 'report' ? theme3 : '', 
							onRoutes == 'companyStatistics' ? theme3 : '', 
							onRoutes == 'seating' ? theme3 : '']">统计管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="report" :class="onRoutes == 'report' ? theme6 : ''">员工统计报表</el-menu-item>
					<el-menu-item index="companyStatistics"
						:class="onRoutes == 'companyStatistics' ? theme6 : ''">公司统计报表</el-menu-item>
					<el-menu-item index="seating" :class="onRoutes == 'seating' ? theme6 : ''">坐席数据</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="termOfValidity" :class="onRoutes == 'termOfValidity' ? theme3 : ''">
				<i class="el-icon-time"></i>
				<span>有效期管理</span>
			</el-menu-item>

			<el-submenu index="cardType">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'cardType' ? theme3 : '',
							onRoutes == 'blackListDatabase' ? theme3 : '',
							onRoutes == 'userSerial' ? theme3 : '',
							onRoutes == 'role' ? theme3 : '',
							onRoutes == 'operationLog' ? theme3 : '',
							onRoutes == 'outboundCallRecords' ? theme3 : '',
							onRoutes == 'subagent' ? theme3 : '',
							onRoutes == 'flowManagement' ? theme3 : '',
							onRoutes == 'setColor' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe990;</span>
					<span :class="[
							onRoutes == 'cardType' ? theme3 : '',
							onRoutes == 'blackListDatabase' ? theme3 : '',
							onRoutes == 'userSerial' ? theme3 : '',
							onRoutes == 'role' ? theme3 : '',
							onRoutes == 'operationLog' ? theme3 : '',
							onRoutes == 'outboundCallRecords' ? theme3 : '',
							onRoutes == 'subagent' ? theme3 : '',
							onRoutes == 'flowManagement' ? theme3 : '',
							onRoutes == 'setColor' ? theme3 : ''
						]">系统设置
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="cardType" :class="onRoutes == 'cardType' ? theme6 : ''">品牌管理</el-menu-item>
					<el-menu-item index="subagent" :class="onRoutes == 'subagent' ? theme6 : ''">子代理列表</el-menu-item>
					<el-menu-item index="flowManagement"
						:class="onRoutes == 'flowManagement' ? theme6 : ''">流水管理</el-menu-item>
					<!-- //在领尚注释!-->
					<!-- <el-menu-item index="blackListDatabase" :class="onRoutes == 'blackListDatabase' ? theme6 : ''">黑名单库</el-menu-item> -->
					<!-- <el-menu-item index="userSerial" :class="onRoutes == 'userSerial' ? theme6 : ''">员工分配记录</el-menu-item> -->
					<el-menu-item index="role" :class="onRoutes == 'role' ? theme6 : ''">角色管理</el-menu-item>
					<!-- //在领尚注释!-->
					<el-menu-item index="operationLog"
						:class="onRoutes == 'operationLog' ? theme6 : ''">员工操作日志</el-menu-item>
					<el-menu-item index="outboundCallRecords"
						:class="onRoutes == 'outboundCallRecords' ? theme6 : ''">外呼记录</el-menu-item>
					<el-menu-item index="setColor" :class="onRoutes == 'setColor' ? theme6 : ''">设置主题</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="trumpetTemplate">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'trumpetTemplate' ? theme3 : '',
							onRoutes == 'trumpetenterpriseAllocation' ? theme3 : '',
							onRoutes == 'tonglianPrecisionTube' ? theme3 : '',
							onRoutes == 'premium' ? theme3 : '',
							onRoutes == 'trumpetspecialServiceNumber' ? theme3 : '',
							onRoutes == 'trumpetFTConsumptionDetails' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe9c2;</span>
					<span :class="[
							onRoutes == 'trumpetTemplate' ? theme3 : '',
							onRoutes == 'trumpetenterpriseAllocation' ? theme3 : '',
							onRoutes == 'trumpetspecialServiceNumber' ? theme3 : '',
							onRoutes == 'premium' ? theme3 : '',
							onRoutes == 'tonglianPrecisionTube' ? theme3 : '',
							onRoutes == 'trumpetFTConsumptionDetails' ? theme3 : '',
						]">云呼管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="tonglianPrecisionTube"
						:class="onRoutes == 'tonglianPrecisionTube' ? theme6 : ''">云呼面板</el-menu-item>
					<el-menu-item index="trumpetTemplate"
						:class="onRoutes == 'trumpetTemplate' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="trumpetenterpriseAllocation"
						:class="onRoutes == 'trumpetenterpriseAllocation' ? theme6 : ''">企业套餐</el-menu-item>
					<el-menu-item index="trumpetspecialServiceNumber"
						:class="onRoutes == 'trumpetspecialServiceNumber' ? theme6 : ''">号码状态</el-menu-item>
					<el-menu-item index="trumpetFTConsumptionDetails"
						:class="onRoutes == 'trumpetFTConsumptionDetails' ? theme6 : ''">账单明细</el-menu-item>
					<el-menu-item index="premium" :class="onRoutes == 'premium' ? theme6 : ''">溢价</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<!-- <el-submenu index="cdrBatchManagement">
				<template v-slot:title>
					<i class="el-icon-box" :class="[
						onRoutes == 'cdrBatchAllocation' ? theme3 : '',
						onRoutes == 'cdrBatchConsumptionDetails' ? theme3 : '',
						onRoutes == 'cdrBatchList' ? theme3 : '',
						onRoutes == 'cdrBatchManagement' ? theme3 : '',
						onRoutes == 'cdrBatchPremium' ? theme3 : '',
						onRoutes == 'cdrBatchServer' ? theme3 : '',
						onRoutes == 'cdrBatchType' ? theme3 : '',]"></i>
					<span :class="[
							onRoutes == 'cdrBatchAllocation' ? theme3 : '',
							onRoutes == 'cdrBatchConsumptionDetails' ? theme3 : '',
							onRoutes == 'cdrBatchList' ? theme3 : '',
							onRoutes == 'cdrBatchManagement' ? theme3 : '',
							onRoutes == 'cdrBatchPremium' ? theme3 : '',
							onRoutes == 'cdrBatchServer' ? theme3 : '',
							onRoutes == 'cdrBatchType' ? theme3 : '',
						]">话批管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="cdrBatchManagement"
						:class="onRoutes == 'cdrBatchManagement' ? theme6 : ''">话批面板</el-menu-item>
					<el-menu-item index="cdrBatchList"
						:class="onRoutes == 'cdrBatchList' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="cdrBatchAllocation"
						:class="onRoutes == 'cdrBatchAllocation' ? theme6 : ''">企业套餐</el-menu-item>
					<el-menu-item index="cdrBatchType"
						:class="onRoutes == 'cdrBatchType' ? theme6 : ''">号码状态</el-menu-item>
					<el-menu-item index="cdrBatchConsumptionDetails"
						:class="onRoutes == 'cdrBatchConsumptionDetails' ? theme6 : ''">账单明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<!-- <el-submenu index="panelData">
				<template v-slot:title>
					<i class="el-icon-document-copy" :class="[
						onRoutes == 'panelData' ? theme3 : '',
						onRoutes == 'sipTemplate' ? theme3 : '',
						onRoutes == 'enterpriseAllocation' ? theme3 : '',
						onRoutes == 'FTConsumptionDetails' ? theme3 : '',
						onRoutes == 'specialServiceNumber' ? theme3 : '']"></i>
					<span :class="[
							onRoutes == 'sipTemplate' ? theme3 : '',
							onRoutes == 'panelData' ? theme3 : '',
							onRoutes == 'enterpriseAllocation' ? theme3 : '',
							onRoutes == 'specialServiceNumber' ? theme3 : '',
							onRoutes == 'FTConsumptionDetails' ? theme3 : '',
						]">
						迪加SIP
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="panelData" :class="onRoutes == 'panelData' ? theme6 : ''">数据面板</el-menu-item>
					<el-menu-item index="sipTemplate"
						:class="onRoutes == 'sipTemplate' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="enterpriseAllocation"
						:class="onRoutes == 'enterpriseAllocation' ? theme6 : ''">企业套餐</el-menu-item>
					<el-menu-item index="specialServiceNumber"
						:class="onRoutes == 'specialServiceNumber' ? theme6 : ''">号码列表</el-menu-item>
					<el-menu-item index="FTConsumptionDetails"
						:class="onRoutes == 'FTConsumptionDetails' ? theme6 : ''">账单明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="packageManagementX">
				<template v-slot:title>
					<i class="el-icon-connection" :class="[
							onRoutes == 'hySA' ? theme3 : '',
							onRoutes == 'AXBBinding' ? theme3 : '',
						]"></i>
					<span :class="[
							onRoutes == 'hySA' ? theme3 : '',
							onRoutes == 'AXBBinding' ? theme3 : '',
						]">
						虚商SAXB
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="hySA" :class="onRoutes == 'hySA' ? theme6 : ''">华云SA套餐用量查询</el-menu-item>
					<el-menu-item index="AXBBinding" :class="onRoutes == 'AXBBinding' ? theme6 : ''">绑定查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-submenu index="notice">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'notice' ? theme3 : '', 
							onRoutes == 'addNotice' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe989;</span>
					<span
						:class="[onRoutes == 'notice' ? theme3 : '', onRoutes == 'addNotice' ? theme3 : '']">公告管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="notice" :class="onRoutes == 'notice' ? theme6 : ''">公告列表</el-menu-item>
					<el-menu-item index="addNotice" :class="onRoutes == 'addNotice' ? theme6 : ''">发布公告</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="OEMset">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'OEMset' ? theme3 : '', 
							onRoutes == 'OEMswiper' ? theme3 : '', 
							onRoutes == 'swipes' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe998;</span>
					<span :class="[
							onRoutes == 'OEMset' ? theme3 : '', 
							onRoutes == 'OEMswiper' ? theme3 : '', 
							onRoutes == 'swipes' ? theme3 : '']">OEM管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="OEMset" :class="onRoutes == 'OEMset' ? theme6 : ''">OEM设置</el-menu-item>
					<el-menu-item index="OEMswiper" :class="onRoutes == 'OEMswiper' ? theme6 : ''">登录轮播图</el-menu-item>
					<el-menu-item index="swipes" :class="onRoutes == 'swipes' ? theme6 : ''">APP轮播图</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="blackList" :class="onRoutes == 'blackList' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'blackList' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98b;</span>
				<span>黑名单</span>
			</el-menu-item>
			<!-- <el-menu-item index="validate" :class="onRoutes == 'validate' ? theme3 : ''">
				<i class="el-icon-finished"></i>
				<span>号码验证</span>
			</el-menu-item> -->
			<el-menu-item index="afterSales" :class="onRoutes == 'afterSales' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'afterSales' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe991;</span>
				<span>售后信息</span>
			</el-menu-item>
			<el-menu-item index="operationManual" v-if="webName == '云企通'"
				:class="onRoutes == 'operationManual' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<el-menu-item index="operationManual2" v-if="webName == '橙逸通信'"
				:class="onRoutes == 'operationManual2' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual2' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<div class="login_info" v-if="collapse == false">
				<div>最后登录时间:{{ lastLoginAt }}</div>
			</div>
		</el-menu>

		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router
			v-else-if="role == 'subAgent'">
			<el-menu-item index="dashboard" :class="onRoutes == 'dashboard' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'dashboard' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">&#xe6af;</span>
				<span>系统首页</span>
			</el-menu-item>
			<el-submenu index="advancedSearch" v-if="CY">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe99c;</span>
					<span :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : ''
						]">寻迹通
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="advancedSearch"
						:class="onRoutes == 'advancedSearch' ? theme6 : ''">找线索</el-menu-item>
					<el-menu-item index="companySearch"
						:class="onRoutes == 'companySearch' ? theme6 : ''">找企业</el-menu-item>
					<el-menu-item index="shopSearch" :class="onRoutes == 'shopSearch' ? theme6 : ''">找店铺</el-menu-item>
					<el-menu-item index="industryTemplate"
						:class="onRoutes == 'industryTemplate' ? theme6 : ''">找行业</el-menu-item>
					<el-menu-item index="mapSearch" :class="onRoutes == 'mapSearch' ? theme6 : ''">地图找客</el-menu-item>
					<el-menu-item index="batchCheckCompany"
						:class="onRoutes == 'batchCheckCompany' ? theme6 : ''">批量查询</el-menu-item>
					<el-menu-item index="poolAccount"
						:class="onRoutes == 'poolAccount' ? theme6 : ''">账号管理</el-menu-item>
					<el-menu-item-group><el-menu-item index="highSeas"
							:class="onRoutes == 'highSeas' ? theme6 : ''">数据池</el-menu-item></el-menu-item-group>
				</el-menu-item-group>
			</el-submenu>
			<!-- <el-submenu index="packageList">
				<template v-slot:title>
							<span class="icon iconfont" :class="[
														onRoutes == 'packageList' ? theme3 : '',
																onRoutes == 'middleNumber' ? theme3 : '',
																onRoutes == 'consumptionDetails' ? theme3 : '',
																onRoutes == 'privateNumber' ? theme3 : ''
												]" style="font-size:16px !important;margin-right:10px !important;">
								&#xe9b7;</span>
					<span :class="[	onRoutes == 'packageList' ? theme3 : '',
							onRoutes == 'middleNumber' ? theme3 : '',
							onRoutes == 'consumptionDetails' ? theme3 : '',
							onRoutes == 'privateNumber' ? theme3 : '']">回拨管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="packageList"
						:class="onRoutes == 'packageList' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="middleNumber"
						:class="onRoutes == 'middleNumber' ? theme6 : ''">回拨中间号</el-menu-item>
					<el-menu-item index="consumptionDetails"
						:class="onRoutes == 'consumptionDetails' ? theme6 : ''">消费明细</el-menu-item>
					<el-menu-item index="privateNumber"
						:class="onRoutes == 'privateNumber' ? theme6 : ''">私人号码</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<!-- <el-submenu index="AXBinventory">
				<template v-slot:title>
					<i class="el-icon-guide"
						:class="[onRoutes == 'AXBinventory' ? theme3 : '', onRoutes == 'purchaseList' ? theme3 : '', onRoutes == 'consultationDetailed' ? theme3 : '']"></i>
					<span
						:class="[onRoutes == 'AXBinventory' ? theme3 : '', onRoutes == 'purchaseList' ? theme3 : '', onRoutes == 'consultationDetailed' ? theme3 : '']">AXB</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="AXBinventory"
						:class="onRoutes == 'AXBinventory' ? theme6 : ''">AXB库存</el-menu-item>
					<el-menu-item index="purchaseList"
						:class="onRoutes == 'purchaseList' ? theme6 : ''">已购号码</el-menu-item>
					<el-menu-item index="consultationDetailed"
						:class="onRoutes == 'consultationDetailed' ? theme6 : ''">消费明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-submenu index="customer">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;">&#xe645;</span>
					<span :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'automaticRecycling' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]">CRM管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="CRMstatistics"
						:class="onRoutes == 'CRMstatistics' ? theme6 : ''">统计报表</el-menu-item>
					<el-menu-item index="customer" :class="onRoutes == 'customer' ? theme6 : ''">我的客户</el-menu-item>
					<el-menu-item index="CRMHigh" :class="onRoutes == 'CRMHigh' ? theme6 : ''">公海客户</el-menu-item>
					<!-- <el-menu-item index="CRMDepartmentHigh"
						:class="onRoutes == 'CRMDepartmentHigh' ? theme6 : ''">部门公海</el-menu-item> -->
					<el-menu-item index="customTag" :class="onRoutes == 'customTag' ? theme6 : ''">字段配置</el-menu-item>
					<el-menu-item index="followProgress"
						:class="onRoutes == 'followProgress' ? theme6 : ''">跟进阶段配置</el-menu-item>
					<el-menu-item index="CRMsource" :class="onRoutes == 'CRMsource' ? theme6 : ''">来源配置</el-menu-item>
					<el-menu-item index="release" :class="onRoutes == 'release' ? theme6 : ''">释放管理</el-menu-item>
					<el-menu-item index="automaticRecycling"
						:class="onRoutes == 'automaticRecycling' ? theme6 : ''">自动回收</el-menu-item>
					<el-menu-item index="tag" :class="onRoutes == 'tag' ? theme6 : ''">标签管理</el-menu-item>
					<el-menu-item index="clueCollection"
						:class="onRoutes == 'clueCollection' ? theme6 : ''">领取记录</el-menu-item>
					<el-menu-item index="operationRecord"
						:class="onRoutes == 'operationRecord' ? theme6 : ''">操作记录</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="clue">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'clue' ? theme3 : '', 
							onRoutes == 'assignLeads' ? theme3 : '', 
							onRoutes == 'groupCall' ? theme3 : '', 
							onRoutes == 'cluePool' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;font-weight: 600;">&#xe738;</span>
					<span :class="[onRoutes == 'clue' ? theme3 : '', 
						onRoutes == 'assignLeads' ? theme3 : '', 
						onRoutes == 'groupCall' ? theme3 : '', 
						onRoutes == 'cluePool' ? theme3 : '']">线索管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="clue" :class="onRoutes == 'clue' ? theme6 : ''">线索列表</el-menu-item>
					<!-- <el-menu-item index="groupCall" :class="onRoutes == 'groupCall' ? theme6 : ''">群呼列表</el-menu-item> -->
					<el-menu-item index="assignLeads"
						:class="onRoutes == 'assignLeads' ? theme6 : ''">线索回收</el-menu-item>
					<el-menu-item index="cluePool" :class="onRoutes == 'cluePool' ? theme6 : ''">线索池</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="company">
				<template v-slot:title>
					<span class="icon iconfont" :class="[onRoutes == 'company' ? theme3 : '', 
						onRoutes == 'department' ? theme3 : '', 
						onRoutes == 'user' ? theme3 : '', 
						onRoutes == 'addressErrList' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">&#xe818;</span>
					<span :class="[onRoutes == 'company' ? theme3 : '', 
						onRoutes == 'department' ? theme3 : '', 
						onRoutes == 'user' ? theme3 : '', 
						onRoutes == 'addressErrList' ? theme3 : '']">企业管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="company" :class="onRoutes == 'company' ? theme6 : ''">企业列表</el-menu-item>
					<el-menu-item index="department" :class="onRoutes == 'department' ? theme6 : ''">部门管理</el-menu-item>
					<el-menu-item index="user" :class="onRoutes == 'user' ? theme6 : ''">员工管理</el-menu-item>

				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="record" :class="onRoutes == 'record' ? theme3 : ''">
				<span class="icon iconfont" :class="[onRoutes == 'record' ? theme3 : '']"
					style="font-size:16px !important;margin-right:10px !important;font-weight: 600;;">&#xe64b;</span>
				<span>通话记录</span>
			</el-menu-item>

			<el-submenu index="userInfo" v-if="webName == '云企通'">
				<template v-slot:title>
					<i class="el-icon-bank-card" :class="[onRoutes == 'userInfo' ? theme3 : '',
						 onRoutes == 'activationList' ? theme3 : '', 
						 onRoutes == 'DJAbnormalCallList' ? theme3 : '', 
						 onRoutes == 'accountReview' ? theme3 : '', ]"></i>
					<span :class="[
							onRoutes == 'userInfo' ? theme3 : '',
							onRoutes == 'activationList' ? theme3 : '',
							onRoutes == 'DJAbnormalCallList' ? theme3 : '',
							onRoutes == 'accountReview' ? theme3 : ''
						]">迪加管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="userInfo" :class="onRoutes == 'userInfo' ? theme6 : ''">迪加查询</el-menu-item>
					<el-menu-item index="activationList"
						:class="onRoutes == 'activationList' ? theme6 : ''">限制返档</el-menu-item>
					<el-menu-item index="DJAbnormalCallList"
						:class="onRoutes == 'DJAbnormalCallList' ? theme6 : ''">迪加异常话单</el-menu-item>
					<el-menu-item index="accountReview"
						:class="onRoutes == 'accountReview' ? theme6 : ''">开户审核查询</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="addReturns" v-if="webName == '云企通'">
				<template v-slot:title>
					<span class="icon iconfont" :class="onRoutes == 'addReturns' ? theme3 : ''"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe98f;</span>
					<span :class="onRoutes == 'addReturns' ? theme3 : ''">充值管理</span>
				</template>
				<el-menu-item-group><el-menu-item index="addReturns"
						:class="onRoutes == 'addReturns' ? theme6 : ''">蜗牛充值</el-menu-item></el-menu-item-group>
			</el-submenu>

			<el-submenu index="report">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'report' ? theme3 : '',
							onRoutes == 'report' ? theme3 : '',
							onRoutes == 'companyStatistics' ? theme3 : '', 
							onRoutes == 'seating' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe9b1;</span>
					<span :class="[
							onRoutes == 'report' ? theme3 : '', 
							onRoutes == 'companyStatistics' ? theme3 : '', 
							onRoutes == 'seating' ? theme3 : '']">统计管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="report" :class="onRoutes == 'report' ? theme6 : ''">员工统计报表</el-menu-item>
					<el-menu-item index="companyStatistics"
						:class="onRoutes == 'companyStatistics' ? theme6 : ''">公司统计报表</el-menu-item>
					<el-menu-item index="seating" :class="onRoutes == 'seating' ? theme6 : ''">坐席数据</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<!-- <el-menu-item index="termOfValidity" :class="onRoutes == 'termOfValidity' ? theme3 : ''">
				<i class="el-icon-time"></i>
				<span>有效期管理</span>
			</el-menu-item> -->

			<el-submenu index="cardType">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'cardType' ? theme3 : '',
							onRoutes == 'blackListDatabase' ? theme3 : '',
							onRoutes == 'userSerial' ? theme3 : '',
							onRoutes == 'role' ? theme3 : '',
							onRoutes == 'operationLog' ? theme3 : '',
							onRoutes == 'outboundCallRecords' ? theme3 : '',
							onRoutes == 'subagent' ? theme3 : '',
							onRoutes == 'setColor' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe990;</span>
					<span :class="[
							onRoutes == 'cardType' ? theme3 : '',
							onRoutes == 'blackListDatabase' ? theme3 : '',
							onRoutes == 'userSerial' ? theme3 : '',
							onRoutes == 'role' ? theme3 : '',
							onRoutes == 'operationLog' ? theme3 : '',
							onRoutes == 'outboundCallRecords' ? theme3 : '',
							onRoutes == 'subagent' ? theme3 : '',
							onRoutes == 'setColor' ? theme3 : ''
						]">系统设置
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="cardType" :class="onRoutes == 'cardType' ? theme6 : ''">品牌管理</el-menu-item>
					<!-- <el-menu-item index="subagent" :class="onRoutes == 'subagent' ? theme6 : ''">子代理列表</el-menu-item> -->
					<!-- //在领尚注释!-->
					<!-- <el-menu-item index="blackListDatabase" :class="onRoutes == 'blackListDatabase' ? theme6 : ''">黑名单库</el-menu-item> -->
					<!-- <el-menu-item index="userSerial" :class="onRoutes == 'userSerial' ? theme6 : ''">员工分配记录</el-menu-item> -->
					<!-- <el-menu-item index="role" :class="onRoutes == 'role' ? theme6 : ''">角色管理</el-menu-item> -->
					<!-- //在领尚注释!-->
					<!-- <el-menu-item index="operationLog" :class="onRoutes == 'operationLog' ? theme6 : ''">员工操作日志</el-menu-item> -->
					<el-menu-item index="outboundCallRecords"
						:class="onRoutes == 'outboundCallRecords' ? theme6 : ''">外呼记录</el-menu-item>
					<el-menu-item index="setColor" :class="onRoutes == 'setColor' ? theme6 : ''">设置主题</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="notice">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'notice' ? theme3 : '', 
							onRoutes == 'addNotice' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe989;</span>
					<span :class="[
							onRoutes == 'notice' ? theme3 : '', 
							onRoutes == 'addNotice' ? theme3 : '']">公告管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="notice" :class="onRoutes == 'notice' ? theme6 : ''">公告列表</el-menu-item>
					<el-menu-item index="addNotice" :class="onRoutes == 'addNotice' ? theme6 : ''">发布公告</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="OEMset">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'OEMset' ? theme3 : '', 
							onRoutes == 'OEMswiper' ? theme3 : '', 
							onRoutes == 'swipes' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe998;</span>
					<span :class="[
							onRoutes == 'OEMset' ? theme3 : '', 
							onRoutes == 'OEMswiper' ? theme3 : '', 
							onRoutes == 'swipes' ? theme3 : '']">OEM管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="OEMset" :class="onRoutes == 'OEMset' ? theme6 : ''">OEM设置</el-menu-item>
					<el-menu-item index="OEMswiper" :class="onRoutes == 'OEMswiper' ? theme6 : ''">登录轮播图</el-menu-item>
					<el-menu-item index="swipes" :class="onRoutes == 'swipes' ? theme6 : ''">APP轮播图</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="blackList" :class="onRoutes == 'blackList' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'blackList' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98b;</span>
				<span>黑名单</span>
			</el-menu-item>
			<!-- <el-menu-item index="validate" :class="onRoutes == 'validate' ? theme3 : ''">
				<i class="el-icon-finished"></i>
				<span>号码验证</span>
			</el-menu-item> -->
			<el-menu-item index="afterSales" :class="onRoutes == 'afterSales' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'afterSales' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe991;</span>
				<span>售后信息</span>
			</el-menu-item>
			<el-menu-item index="operationManual" v-if="webName == '云企通'"
				:class="onRoutes == 'operationManual' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<el-menu-item index="operationManual2" v-if="webName == '橙逸通信'"
				:class="onRoutes == 'operationManual2' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual2' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<div class="login_info" v-if="collapse == false">
				<div>最后登录时间:{{ lastLoginAt }}</div>
			</div>
		</el-menu>

		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router
			v-else-if="role == 'company'">
			<el-menu-item index="dashboard" :class="onRoutes == 'dashboard' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'dashboard' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">&#xe6af;</span>
				<span>系统首页</span>
			</el-menu-item>
			<el-submenu index="advancedSearch" v-if="CY">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe99c;</span>
					<span :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : ''
						]">寻迹通
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="advancedSearch"
						:class="onRoutes == 'advancedSearch' ? theme6 : ''">找线索</el-menu-item>
					<el-menu-item index="companySearch"
						:class="onRoutes == 'companySearch' ? theme6 : ''">找企业</el-menu-item>
					<el-menu-item index="shopSearch" :class="onRoutes == 'shopSearch' ? theme6 : ''">找店铺</el-menu-item>
					<el-menu-item index="industryTemplate"
						:class="onRoutes == 'industryTemplate' ? theme6 : ''">找行业</el-menu-item>
					<el-menu-item index="mapSearch" :class="onRoutes == 'mapSearch' ? theme6 : ''">地图找客</el-menu-item>
					<el-menu-item index="batchCheckCompany"
						:class="onRoutes == 'batchCheckCompany' ? theme6 : ''">批量查询</el-menu-item>
					<el-menu-item index="poolAccount"
						:class="onRoutes == 'poolAccount' ? theme6 : ''">账号管理</el-menu-item>
					<el-menu-item-group><el-menu-item index="highSeas"
							:class="onRoutes == 'highSeas' ? theme6 : ''">数据池</el-menu-item></el-menu-item-group>
				</el-menu-item-group>
			</el-submenu>
			<!-- <el-submenu index="packageManagement">
				<template v-slot:title>
					<i class="el-icon-guide"
						:class="[onRoutes == 'purchaseList' ? theme3 : '', onRoutes == 'consultationDetailed' ? theme3 : '']"></i>
					<span
						:class="[onRoutes == 'purchaseList' ? theme3 : '', onRoutes == 'consultationDetailed' ? theme3 : '']">AXB</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="purchaseList"
						:class="onRoutes == 'purchaseList' ? theme6 : ''">已购号码</el-menu-item>
					<el-menu-item index="consultationDetailed"
						:class="onRoutes == 'consultationDetailed' ? theme6 : ''">消费明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-submenu index="customer">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'modou' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;">&#xe645;</span>
					<span :class="[
							onRoutes == 'customer' ? theme3 : '',
							onRoutes == 'customTag' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'followProgress' ? theme3 : '',
							onRoutes == 'CRMsource' ? theme3 : '',
							onRoutes == 'release' ? theme3 : '',
							onRoutes == 'automaticRecycling' ? theme3 : '',
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '',
							onRoutes == 'modou' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : ''
						]">CRM管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="CRMstatistics"
						:class="onRoutes == 'CRMstatistics' ? theme6 : ''">统计报表</el-menu-item>
					<el-menu-item index="customer" :class="onRoutes == 'customer' ? theme6 : ''">我的客户</el-menu-item>
					<el-menu-item index="CRMHigh" :class="onRoutes == 'CRMHigh' ? theme6 : ''">公海客户</el-menu-item>
					<!-- <el-menu-item index="CRMDepartmentHigh"
						:class="onRoutes == 'CRMDepartmentHigh' ? theme6 : ''">部门公海</el-menu-item> -->
					<el-menu-item index="customTag" :class="onRoutes == 'customTag' ? theme6 : ''">字段配置</el-menu-item>
					<el-menu-item index="followProgress"
						:class="onRoutes == 'followProgress' ? theme6 : ''">跟进阶段配置</el-menu-item>
					<el-menu-item index="CRMsource" :class="onRoutes == 'CRMsource' ? theme6 : ''">来源配置</el-menu-item>
					<el-menu-item index="release" :class="onRoutes == 'release' ? theme6 : ''">释放管理</el-menu-item>
					<el-menu-item index="automaticRecycling"
						:class="onRoutes == 'automaticRecycling' ? theme6 : ''">自动回收</el-menu-item>
					<el-menu-item index="tag" :class="onRoutes == 'tag' ? theme6 : ''">标签管理</el-menu-item>
					<el-menu-item index="modou" :class="onRoutes == 'modou' ? theme6 : ''">模版管理</el-menu-item>
					<el-menu-item index="clueCollection"
						:class="onRoutes == 'clueCollection' ? theme6 : ''">领取记录</el-menu-item>
					<el-menu-item index="operationRecord"
						:class="onRoutes == 'operationRecord' ? theme6 : ''">操作记录</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="clue">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'clue' ? theme3 : '', 
							onRoutes == 'assignLeads' ? theme3 : '', 
							onRoutes == 'groupCall' ? theme3 : '', 
							onRoutes == 'cluePool' ? theme3 : ''
						]" style="font-size:16px !important;margin-right:10px !important;font-weight: 600;">&#xe738;</span>
					<span :class="[onRoutes == 'clue' ? theme3 : '', 
						onRoutes == 'assignLeads' ? theme3 : '', 
						onRoutes == 'groupCall' ? theme3 : '', 
						onRoutes == 'cluePool' ? theme3 : '']">线索管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="clue" :class="onRoutes == 'clue' ? theme6 : ''">线索列表</el-menu-item>
					<!-- <el-menu-item index="groupCall" :class="onRoutes == 'groupCall' ? theme6 : ''">群呼列表</el-menu-item> -->
					<el-menu-item index="assignLeads"
						:class="onRoutes == 'assignLeads' ? theme6 : ''">线索回收</el-menu-item>
					<el-menu-item index="cluePool" :class="onRoutes == 'cluePool' ? theme6 : ''">线索池</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="company">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'company' ? theme3 : '', 
							onRoutes == 'department' ? theme3 : '', 
							onRoutes == 'user' ? theme3 : '', 
							onRoutes == 'addressErrList' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">&#xe818;</span>
					<span :class="[
							onRoutes == 'company' ? theme3 : '', 
							onRoutes == 'department' ? theme3 : '', 
							onRoutes == 'user' ? theme3 : '', 
							onRoutes == 'addressErrList' ? theme3 : '']">企业管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="company" :class="onRoutes == 'company' ? theme6 : ''">企业列表</el-menu-item>
					<el-menu-item index="department" :class="onRoutes == 'department' ? theme6 : ''">部门管理</el-menu-item>
					<el-menu-item index="user" :class="onRoutes == 'user' ? theme6 : ''">员工管理</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="record" :class="onRoutes == 'record' ? theme3 : ''">
				<span class="icon iconfont" :class="[onRoutes == 'record' ? theme3 : '']"
					style="font-size:16px !important;margin-right:10px !important;font-weight: 600;;">&#xe64b;</span>
				<span>通话记录</span>
			</el-menu-item>
			<!-- <el-submenu index="enterpriseAllocation">
				<template v-slot:title>
					<i class="el-icon-document-copy" :class="[
						onRoutes == 'enterpriseAllocation' ? theme3 : '',
						onRoutes == 'specialServiceNumber' ? theme3 : '',
						onRoutes == 'FTConsumptionDetails' ? theme3 : '']"></i>
					<span :class="[
							onRoutes == 'enterpriseAllocation' ? theme3 : '',
							onRoutes == 'specialServiceNumber' ? theme3 : '',
							onRoutes == 'FTConsumptionDetails' ? theme3 : '',
						]">SIP管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="enterpriseAllocation"
						:class="onRoutes == 'enterpriseAllocation' ? theme6 : ''">企业分配</el-menu-item>
					<el-menu-item index="specialServiceNumber"
						:class="onRoutes == 'specialServiceNumber' ? theme6 : ''">特服号</el-menu-item>
					<el-menu-item index="FTConsumptionDetails"
						:class="onRoutes == 'FTConsumptionDetails' ? theme6 : ''">消费明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-submenu index="addReturns" v-if="webName == '云企通'" :class="onRoutes == 'addReturns' ? theme3 : ''">
				<template v-slot:title>
					<span class="icon iconfont" :class="onRoutes == 'addReturns' ? theme3 : ''"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe98f;</span>
					<span :class="onRoutes == 'addReturns' ? theme3 : ''">充值管理</span>
				</template>
				<el-menu-item-group><el-menu-item index="addReturns"
						:class="onRoutes == 'addReturns' ? theme6 : ''">蜗牛充值</el-menu-item></el-menu-item-group>
			</el-submenu>
			<el-submenu index="report">
				<template v-slot:title>
					<span class="icon iconfont" :class="onRoutes == 'report' ? theme3 : ''"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe9b1;</span>
					<span :class="onRoutes == 'report' ? theme3 : ''">统计管理</span>
				</template>
				<el-menu-item-group><el-menu-item index="report"
						:class="onRoutes == 'report' ? theme6 : ''">员工统计报表</el-menu-item></el-menu-item-group>
			</el-submenu>

			<el-submenu index="trumpetenterpriseAllocation">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'trumpetenterpriseAllocation' ? theme3 : '',
							onRoutes == 'tonglianPrecisionTube' ? theme3 : '',
							onRoutes == 'trumpetspecialServiceNumber' ? theme3 : '',
							onRoutes == 'trumpetFTConsumptionDetails' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe9c2;</span>
					<span :class="[
							onRoutes == 'trumpetenterpriseAllocation' ? theme3 : '',
							onRoutes == 'tonglianPrecisionTube' ? theme3 : '',
							onRoutes == 'trumpetspecialServiceNumber' ? theme3 : '',
							onRoutes == 'trumpetFTConsumptionDetails' ? theme3 : '',
						]">云呼管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="tonglianPrecisionTube"
						:class="onRoutes == 'tonglianPrecisionTube' ? theme6 : ''">云呼面板</el-menu-item>
					<el-menu-item index="trumpetenterpriseAllocation"
						:class="onRoutes == 'trumpetenterpriseAllocation' ? theme6 : ''">企业套餐</el-menu-item>
					<el-menu-item index="trumpetspecialServiceNumber"
						:class="onRoutes == 'trumpetspecialServiceNumber' ? theme6 : ''">号码状态</el-menu-item>
					<el-menu-item index="trumpetFTConsumptionDetails"
						:class="onRoutes == 'trumpetFTConsumptionDetails' ? theme6 : ''">账单明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<!-- <el-submenu index="cdrBatchManagement">
				<template v-slot:title>
					<i class="el-icon-box" :class="[
						onRoutes == 'cdrBatchAllocation' ? theme3 : '',
						onRoutes == 'cdrBatchConsumptionDetails' ? theme3 : '',
						onRoutes == 'cdrBatchList' ? theme3 : '',
						onRoutes == 'cdrBatchManagement' ? theme3 : '',
						onRoutes == 'cdrBatchPremium' ? theme3 : '',
						onRoutes == 'cdrBatchServer' ? theme3 : '',
						onRoutes == 'cdrBatchType' ? theme3 : '',]"></i>
					<span :class="[
							onRoutes == 'cdrBatchAllocation' ? theme3 : '',
							onRoutes == 'cdrBatchConsumptionDetails' ? theme3 : '',
							onRoutes == 'cdrBatchList' ? theme3 : '',
							onRoutes == 'cdrBatchManagement' ? theme3 : '',
							onRoutes == 'cdrBatchPremium' ? theme3 : '',
							onRoutes == 'cdrBatchServer' ? theme3 : '',
							onRoutes == 'cdrBatchType' ? theme3 : '',
						]">话批管理
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="cdrBatchManagement"
						:class="onRoutes == 'cdrBatchManagement' ? theme6 : ''">话批面板</el-menu-item>
					<el-menu-item index="cdrBatchAllocation"
						:class="onRoutes == 'cdrBatchAllocation' ? theme6 : ''">企业套餐</el-menu-item>
					<el-menu-item index="cdrBatchType"
						:class="onRoutes == 'cdrBatchType' ? theme6 : ''">号码状态</el-menu-item>
					<el-menu-item index="cdrBatchConsumptionDetails"
						:class="onRoutes == 'cdrBatchConsumptionDetails' ? theme6 : ''">账单明细</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<!-- <el-submenu index="packageList">
				<template v-slot:title>				
							<span class="icon iconfont" :class="[
														onRoutes == 'packageList' ? theme3 : '',
																onRoutes == 'middleNumber' ? theme3 : '',
																onRoutes == 'consumptionDetails' ? theme3 : '',
																onRoutes == 'privateNumber' ? theme3 : ''
												]" style="font-size:16px !important;margin-right:10px !important;">
								&#xe9b7;</span>
					<span :class="[	onRoutes == 'packageList' ? theme3 : '',
							onRoutes == 'middleNumber' ? theme3 : '',
							onRoutes == 'consumptionDetails' ? theme3 : '',
							onRoutes == 'privateNumber' ? theme3 : '']">回拨管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="packageList"
						:class="onRoutes == 'packageList' ? theme6 : ''">套餐列表</el-menu-item>
					<el-menu-item index="middleNumber"
						:class="onRoutes == 'middleNumber' ? theme6 : ''">回拨中间号</el-menu-item>
					<el-menu-item index="consumptionDetails"
						:class="onRoutes == 'consumptionDetails' ? theme6 : ''">消费明细</el-menu-item>
					<el-menu-item index="privateNumber"
						:class="onRoutes == 'privateNumber' ? theme6 : ''">私人号码</el-menu-item>
				</el-menu-item-group>
			</el-submenu> -->
			<el-menu-item index="accountReview" :class="onRoutes == 'accountReview' ? theme6 : ''">
				<span class="icon iconfont" :class="onRoutes == 'accountReview' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98f;</span>
				<span>开户审核查询</span>
			</el-menu-item>
			<el-menu-item index="blackList" :class="onRoutes == 'blackList' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'blackList' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98b;</span>
				<span>黑名单</span>
			</el-menu-item>
			<!-- <el-menu-item index="validate" :class="onRoutes == 'validate' ? theme3 : ''">
				<i class="el-icon-finished"></i>
				<span>号码验证</span>
			</el-menu-item> -->
			<el-menu-item index="operationManual" v-if="webName == '云企通'"
				:class="onRoutes == 'operationManual' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<el-menu-item index="operationManual2" v-if="webName == '橙逸通信'"
				:class="onRoutes == 'operationManual2' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual2' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<div class="login_info" v-if="collapse == false">
				<div>最后登录时间:{{ lastLoginAt }}</div>
			</div>
		</el-menu>
		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router
			v-else-if="role == 'normal'">
			<el-menu-item index="dashboard" :class="onRoutes == 'dashboard' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'dashboard' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">&#xe6af;</span>
				<span>系统首页</span>
			</el-menu-item>
			<el-submenu index="advancedSearch" v-if="CY">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe99c;</span>
					<span :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : ''
						]">寻迹通
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="advancedSearch"
						:class="onRoutes == 'advancedSearch' ? theme6 : ''">找线索</el-menu-item>
					<el-menu-item index="companySearch"
						:class="onRoutes == 'companySearch' ? theme6 : ''">找企业</el-menu-item>
					<el-menu-item index="shopSearch" :class="onRoutes == 'shopSearch' ? theme6 : ''">找店铺</el-menu-item>
					<el-menu-item index="industryTemplate"
						:class="onRoutes == 'industryTemplate' ? theme6 : ''">找行业</el-menu-item>
					<el-menu-item index="mapSearch" :class="onRoutes == 'mapSearch' ? theme6 : ''">地图找客</el-menu-item>
					<el-menu-item index="batchCheckCompany"
						:class="onRoutes == 'batchCheckCompany' ? theme6 : ''">批量查询</el-menu-item>
					<el-menu-item index="poolAccount"
						:class="onRoutes == 'poolAccount' ? theme6 : ''">账号管理</el-menu-item>
					<el-menu-item-group><el-menu-item index="highSeas"
							:class="onRoutes == 'highSeas' ? theme6 : ''">数据池</el-menu-item></el-menu-item-group>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="customer">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
						 	onRoutes == 'customer' ? theme3 : '',
						 	onRoutes == 'CRMHigh' ? theme3 : '',
						 	onRoutes == 'CRMstatistics' ? theme3 : '',
						 	onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
						 	onRoutes == 'tag' ? theme3 : '',
						 	onRoutes == 'clueCollection' ? theme3 : '', 
						 	onRoutes == 'operationRecord' ? theme3 : ''
						 ]" style="font-size:16px !important;margin-right:10px !important;">&#xe645;</span>
					<span :class="[
							onRoutes == 'customer' ? theme3 : '', 
							onRoutes == 'CRMHigh' ? theme3 : '',
							onRoutes == 'CRMstatistics' ? theme3 : '',
							onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
							onRoutes == 'tag' ? theme3 : '', 
							onRoutes == 'clueCollection' ? theme3 : '',
							onRoutes == 'operationRecord' ? theme3 : '']">CRM管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="CRMstatistics"
						:class="onRoutes == 'CRMstatistics' ? theme6 : ''">统计报表</el-menu-item>
					<el-menu-item index="customer" :class="onRoutes == 'customer' ? theme6 : ''">我的客户</el-menu-item>
					<el-menu-item index="CRMHigh" :class="onRoutes == 'CRMHigh' ? theme6 : ''">公海客户</el-menu-item>
					<!-- <el-menu-item index="CRMDepartmentHigh"
						:class="onRoutes == 'CRMDepartmentHigh' ? theme6 : ''">部门公海</el-menu-item> -->
					<el-menu-item index="tag" :class="onRoutes == 'tag' ? theme6 : ''">标签管理</el-menu-item>
					<el-menu-item index="clueCollection"
						:class="onRoutes == 'clueCollection' ? theme6 : ''">领取记录</el-menu-item>
					<el-menu-item index="operationRecord"
						:class="onRoutes == 'operationRecord' ? theme6 : ''">操作记录</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="clue">
				<template v-slot:title>
					<span class="icon iconfont"
						:class="[onRoutes == 'clue' ? theme3 : '',onRoutes == 'groupCall' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;font-weight: 600;">&#xe738;</span>
					<span :class="[onRoutes == 'clue' ? theme3 : '',onRoutes == 'groupCall' ? theme3 : '']">线索管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="clue" :class="onRoutes == 'clue' ? theme6 : ''">线索列表</el-menu-item>
					<!-- <el-menu-item index="groupCall" :class="onRoutes == 'groupCall' ? theme6 : ''">群呼列表</el-menu-item> -->
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="record" :class="onRoutes == 'record' ? theme3 : ''">
				<span class="icon iconfont" :class="[onRoutes == 'record' ? theme3 : '']"
					style="font-size:16px !important;margin-right:10px !important;font-weight: 600;;">&#xe64b;</span>
				<span>通话记录</span>
			</el-menu-item>

			<el-submenu index="addReturns" v-if="webName == '云企通'">
				<template v-slot:title>
					<span class="icon iconfont" :class="onRoutes == 'addReturns' ? theme3 : ''"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe98f;</span>
					<span :class="onRoutes == 'addReturns' ? theme3 : ''">充值管理</span>
				</template>
				<el-menu-item-group><el-menu-item index="addReturns"
						:class="onRoutes == 'addReturns' ? theme6 : ''">蜗牛充值</el-menu-item></el-menu-item-group>
			</el-submenu>
			<el-menu-item index="accountReview" :class="onRoutes == 'accountReview' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'accountReview' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98f;</span>
				<span>开户审核查询</span>
			</el-menu-item>
			<el-menu-item index="blackList" :class="onRoutes == 'blackList' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'blackList' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98b;</span>
				<span>黑名单</span>
			</el-menu-item>
			<!-- <el-menu-item index="validate" :class="onRoutes == 'validate' ? theme3 : ''">
				<i class="el-icon-finished"></i>
				<span>号码验证</span>
			</el-menu-item> -->
			<el-menu-item index="operationManual" v-if="webName == '云企通'"
				:class="onRoutes == 'operationManual' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<el-menu-item index="operationManual2" v-if="webName == '橙逸通信'"
				:class="onRoutes == 'operationManual2' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual2' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<div class="login_info" v-if="collapse == false">
				<div>最后登录时间:{{ lastLoginAt }}</div>
			</div>
		</el-menu>
		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router
			v-else-if="role == 'department'">
			<el-menu-item index="dashboard" :class="onRoutes == 'dashboard' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'dashboard' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">&#xe6af;</span>
				<span>系统首页</span>
			</el-menu-item>
			<el-submenu index="advancedSearch" v-if="CY">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : '']" style="font-size:16px !important;margin-right:10px !important;">
						&#xe99c;</span>
					<span :class="[
							onRoutes == 'advancedSearch' ? theme3 : '',
							onRoutes == 'companySearch' ? theme3 : '',
							onRoutes == 'shopSearch' ? theme3 : '',
							onRoutes == 'industryTemplate' ? theme3 : '',
							onRoutes == 'mapSearch' ? theme3 : '',
							onRoutes == 'batchCheckCompany' ? theme3 : '',
							onRoutes == 'poolAccount' ? theme3 : '',
							onRoutes == 'highSeas' ? theme3 : ''
						]">寻迹通
					</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="advancedSearch"
						:class="onRoutes == 'advancedSearch' ? theme6 : ''">找线索</el-menu-item>
					<el-menu-item index="companySearch"
						:class="onRoutes == 'companySearch' ? theme6 : ''">找企业</el-menu-item>
					<el-menu-item index="shopSearch" :class="onRoutes == 'shopSearch' ? theme6 : ''">找店铺</el-menu-item>
					<el-menu-item index="industryTemplate"
						:class="onRoutes == 'industryTemplate' ? theme6 : ''">找行业</el-menu-item>
					<el-menu-item index="mapSearch" :class="onRoutes == 'mapSearch' ? theme6 : ''">地图找客</el-menu-item>
					<el-menu-item index="batchCheckCompany"
						:class="onRoutes == 'batchCheckCompany' ? theme6 : ''">批量查询</el-menu-item>
					<el-menu-item index="poolAccount"
						:class="onRoutes == 'poolAccount' ? theme6 : ''">账号管理</el-menu-item>
					<el-menu-item-group><el-menu-item index="highSeas"
							:class="onRoutes == 'highSeas' ? theme6 : ''">数据池</el-menu-item></el-menu-item-group>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="customer">
				<template v-slot:title>
					<span class="icon iconfont" :class="[
						onRoutes == 'customer' ? theme3 : '',
						onRoutes == 'CRMHigh' ? theme3 : '', 
						onRoutes == 'CRMstatistics' ? theme3 : '', 
						onRoutes == 'CRMDepartmentHigh' ? theme3 : '', 
						onRoutes == 'clueCollection' ? theme3 : '',
						onRoutes == 'operationRecord' ? theme3 : ''
					]" style="font-size:16px !important;margin-right:10px !important;">&#xe645;</span>
					<span :class="[onRoutes == 'customer' ? theme3 : '',
						onRoutes == 'CRMHigh' ? theme3 : '',
						onRoutes == 'CRMstatistics' ? theme3 : '',
						onRoutes == 'CRMDepartmentHigh' ? theme3 : '',
						onRoutes == 'clueCollection' ? theme3 : '',
						onRoutes == 'operationRecord' ? theme3 : '']">CRM管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="CRMstatistics"
						:class="onRoutes == 'CRMstatistics' ? theme6 : ''">统计报表</el-menu-item>
					<el-menu-item index="customer" :class="onRoutes == 'customer' ? theme6 : ''">我的客户</el-menu-item>
					<el-menu-item index="CRMHigh" :class="onRoutes == 'CRMHigh' ? theme6 : ''">公海客户</el-menu-item>
					<!-- <el-menu-item index="CRMDepartmentHigh"
						:class="onRoutes == 'CRMDepartmentHigh' ? theme6 : ''">部门公海</el-menu-item> -->
					<el-menu-item index="clueCollection"
						:class="onRoutes == 'clueCollection' ? theme6 : ''">领取记录</el-menu-item>
					<el-menu-item index="operationRecord"
						:class="onRoutes == 'operationRecord' ? theme6 : ''">操作记录</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="clue">
				<template v-slot:title>
					<span class="icon iconfont"
						:class="[
							onRoutes == 'clue' ? theme3 : '',
							onRoutes == 'groupCall' ? theme3 : '',
							onRoutes == 'assignLeads' ? theme3 : '',
							onRoutes == 'cluePool' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;font-weight: 600;">&#xe738;</span>
					<span
						:class="[onRoutes == 'clue' ? theme3 : '',
						onRoutes == 'groupCall' ? theme3 : '',
						onRoutes == 'assignLeads' ? theme3 : '',
						onRoutes == 'cluePool' ? theme3 : '']">线索管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="clue" :class="onRoutes == 'clue' ? theme6 : ''">线索列表</el-menu-item>
					<!-- <el-menu-item index="groupCall" :class="onRoutes == 'groupCall' ? theme6 : ''">群呼列表</el-menu-item> -->
					<el-menu-item index="assignLeads"
						:class="onRoutes == 'assignLeads' ? theme6 : ''">线索回收</el-menu-item>
					<el-menu-item index="cluePool" :class="onRoutes == 'cluePool' ? theme6 : ''">线索池</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-submenu index="department">
				<template v-slot:title>
					<span class="icon iconfont" :class="onRoutes == 'department' ? theme3 : ''"
						style="font-size:16px !important;margin-right:10px !important;">&#xe818;</span>
					<span :class="onRoutes == 'department' ? theme3 : ''">企业管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="department"
						:class="onRoutes == 'assignLeads' ? theme6 : ''">部门管理</el-menu-item>
					<el-menu-item index="user" :class="onRoutes == 'assignLeads' ? theme6 : ''">员工管理</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-menu-item index="record" :class="onRoutes == 'record' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'record' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;font-weight: 600;;">&#xe64b;</span>
				<span>通话记录</span>
			</el-menu-item>

			<el-submenu index="addReturns" v-if="webName == '云企通'">
				<template v-slot:title>
					<span class="icon iconfont" :class="onRoutes == 'addReturns' ? theme3 : ''"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe98f;</span>
					<span :class="onRoutes == 'addReturns' ? theme3 : ''">充值管理</span>
				</template>
				<el-menu-item-group><el-menu-item index="addReturns"
						:class="onRoutes == 'addReturns' ? theme6 : ''">蜗牛充值</el-menu-item></el-menu-item-group>
			</el-submenu>
			<el-submenu index="report">
				<template v-slot:title>
					<span class="icon iconfont" :class="[onRoutes == 'report' ? theme3 : '']"
						style="font-size:16px !important;margin-right:10px !important;">
						&#xe9b1;</span>
					<span :class="onRoutes == 'report' ? theme3 : ''">统计管理</span>
				</template>
				<el-menu-item-group><el-menu-item index="report"
						:class="onRoutes == 'report' ? theme6 : ''">员工统计报表</el-menu-item></el-menu-item-group>
			</el-submenu>
			<el-menu-item index="accountReview" :class="onRoutes == 'accountReview' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'accountReview' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98f;</span>
				<span>开户审核查询</span>
			</el-menu-item>
			<el-menu-item index="blackList" :class="onRoutes == 'blackList' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'blackList' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe98b;</span>
				<span>黑名单</span>
			</el-menu-item>
			<!-- <el-menu-item index="validate" :class="onRoutes == 'validate' ? theme3 : ''">
				<i class="el-icon-finished"></i>
				<span>号码验证</span>
			</el-menu-item> -->
			<el-menu-item index="operationManual" v-if="webName == '云企通'"
				:class="onRoutes == 'operationManual' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<el-menu-item index="operationManual2" v-if="webName == '橙逸通信'"
				:class="onRoutes == 'operationManual2' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'operationManual2' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">
					&#xe99d;</span>
				<span>使用手册</span>
			</el-menu-item>
			<div class="login_info" v-if="collapse == false">
				<div>最后登录时间:{{ lastLoginAt }}</div>
			</div>
		</el-menu>
		<el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router
			v-else-if="role == 'gm'">
			<el-menu-item index="GM" :class="onRoutes == 'GM' ? theme3 : ''">
				<span class="icon iconfont" :class="onRoutes == 'dashboard' ? theme3 : ''"
					style="font-size:16px !important;margin-right:10px !important;">&#xe6af;</span>
				<span>国美录音</span>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
	// import bus from "../common/bus";
	import {
		getOemInfo
	} from '../api/index.js';
	export default {
		data() {
			return {
				lastLoginIp: '',
				lastLoginAt: '',
				role: '',
				title: '',
				webInfo: '',
				webName: '',
				theme: localStorage.getItem('theme'),
				theme2: localStorage.getItem('theme2'),
				theme3: localStorage.getItem('theme3'),
				theme4: localStorage.getItem('theme4'),
				theme6: localStorage.getItem('theme6'),
				ms_username: localStorage.getItem('ms_username'),
				CRMDepartmentHigh: localStorage.getItem('CRMDepartmentHigh'),
				submit: false,
				CY: true,
				cyURL: 'cytx88.cn'
			};
		},
		computed: {
			onRoutes() {
				console.log(this.$route.name, 'this.$route')
				return this.$route.path.replace('/', '');
			},
			collapse() {

				return this.$store.state.collapse;
			}
		},
		created() {
			this.lastLoginIp = localStorage.getItem('lastLoginIp');
			this.lastLoginAt = localStorage.getItem('lastLoginAt');
			this.getOEMagentOem();
			let role = localStorage.getItem('ms_role');
			this.role = localStorage.getItem('ms_role');
			if (window.location.href.indexOf(this.cyURL) != -1) {
				console.log('我是橙逸，隐藏');
				this.CY = false;
			}
		},
		methods: {
			getOEMagentOem() {
				// let url = 'crm.jilinlingshang.com';// 如果改领尚 切换当前的
				let url = window.location.host; // 如果改云企通 切换当前的
				// let url = 'cytx88.cn'; //如果改橙逸 切换当前
				getOemInfo(url)
					.then(res => {
						if (res?.code === 200) {
							this.webInfo = res.data;
							let linkicon = document.querySelector("link[rel*='icon']") || document.createElement(
								'link');
							linkicon.href = res.data.icon;
							localStorage.setItem('webName', res.data.webName);
							this.webName = res.data.webName;
						} else {
							this.$message.error('查询失败，请稍后再试！');
						}
					})
					.catch(err => {
						this.$message.error('查询失败，请稍后再试！');
					});
			},
			// 侧边栏折叠
			collapseChage() {
				this.$store.commit('hadndleCollapse', !this.collapse);
			}
		}
	};
</script>

<style scoped>
	.collapse-btn {
		float: left;
		padding: 0 21px;
		cursor: pointer;
		line-height: 70px;
	}

	.logo-img .logo {
		float: left;
		height: 100%;
		width: 226px;
		display: flex;
		flex-direction: row;
		align-items: center;
		color: #6c6cf9;
	}

	.logo-img .logo .img {
		width: 42px;
		margin: 0 15px 0 20px;
	}

	.logo-img .logo .img-text {
		width: 94px;
	}

	.logo-img {
		box-sizing: border-box;
		width: 226px;
		height: 70px;
		font-size: 22px;
		margin-bottom: 20px;
		color: #666;
	}

	.sidebar {
		display: block;
		position: absolute;
		width: 226px;
		left: 0;
		top: 0;
		bottom: 0;
		overflow-y: scroll;
	}

	.sidebar::-webkit-scrollbar {
		width: 0;
	}

	.sidebar-el-menu:not(.el-menu--collapse) {
		width: 226px;
	}

	.sidebar>ul {
		height: calc(100%-70px);
	}

	.el-menu--collapse .el-menu-item i {
		position: relative;
		left: -38px;

	}

	.el-menu-item [class^=el-icon-],
	.el-submenu [class^=el-icon-] {
		font-size: 16px !important;
		color: #2c2c2c !important;
		margin-right: 10px !important;
	}

	.el-menu-item span {
		font-size: 14px !important;
	}

	.login_info {
		display: block;
		position: fixed;
		left: 10px;
		bottom: 12px;
	}

	.login_info div {
		font-size: 12px;
	}
</style>
<style>
	.el-menu--collapse * {
		text-align: center !important;
	}

	.el-menu-item .el-menu-item-group__title,
	.el-submenu .el-menu-item-group__title {
		padding: 0;
	}

	.el-menu .el-menu-item,
	.el-menu .el-submenu {
		font-size: 14px !important;
		margin: 0 auto !important;
	}

	.el-menu .el-menu-item.is-active {
		border-radius: 4px;
		background-color: #ecf5ff;
	}

	.el-submenu.is-opened .el-menu .el-menu-item:hover {
		border-radius: 4px !important;
	}

	.el-submenu__title,
	.el-menu-item,
	.el-submenu .el-menu-item {
		height: 48px !important;
		font-size: 14px !important;
		line-height: 48px !important;
	}

	.el-submenu__title,
	.el-submenu .el-menu-item {
		padding-left: 54px !important;
	}

	.el-menu-item {
		border-radius: 4px !important;
		width: 100% !important;
		min-width: 150px !important;
		border: none !important;
	}

	.el-submenu__title {
		padding-left: 20px !important;
		color: #303133 !important;
	}

	.el-submenu__title span {
		font-size: 14px !important;
		color: #303133;
	}
</style>